<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs v-show="xian1" @tab-click="dianji">
        <!-- 过滤策略 -->
        <el-tab-pane label="">
          <span slot="label">{{ $t("logs.Policy_list1") }}</span>
          <div class="main" v-if="this.table_role_show == 1">
            <p>
              <el-button
                @click="add_role_show()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.Policy_list2") }}</el-button
              >
            </p>
          </div>
          <div class="switch1">
            <div class="table table_hover" v-if="this.table_role_show == 1">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList"
                :row-class-name="tableRowClassName"
                class="table-fixed"
                v-loading="loading"
              >
                <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="60">
                </el-table-column>
                <!-- 策略名称 -->

                <el-table-column
                  prop="POLICY_NAME"
                  :label="$t('logs.Policy_list3')"
                  width="126"
                >
                  <template slot-scope="scope">
                    <el-popover placement="left" visible-arrow="false" trigger="hover">
                      <el-button slot="reference" type="text" size="small">{{
                        scope.row.POLICY_NAME
                      }}</el-button>
                      <div>
                        <!-- 删除-->
                        <el-button
                          @click="handleClick_reb(scope.$index, scope.row)"
                          type="text"
                          size="small"
                          :disabled="$root.jurisdiction.only_query == 0"
                        >
                          {{ $t("table1.delete") }}
                        </el-button>
                        <!-- 编辑-->
                        <el-button
                          @click="handleClick2(scope.$index, scope.row)"
                          type="text"
                          size="small"
                          :disabled="$root.jurisdiction.only_query == 0"
                        >
                          {{ $t("table1.ditt") }}
                        </el-button>
                        <!-- 通知设置-->
                        <!-- <el-button
                          @click="handleClick3(scope.$index, scope.row)"
                          type="text"
                          size="small"
                          v-if="scope.row.HAS_NOTIFY == 1"
                          :disabled="$root.jurisdiction.only_query == 0"
                        >
                          {{ notify_mode }}
                        </el-button> -->
                      </div>
                    </el-popover>
                    <!-- 下拉箭头删除-->
                    <!--     <div>
                      <p>
                        {{
                          scope.row.POLICY_NAME 
                        }}
                       
                        <el-button
                          type="text"
                          size="small"
                         icon="el-icon-arrow-down"
                        v-if="scope.row.SHOW_EDIT==0"
                          @click="handleEdit1(scope.$index, scope.row)"
                        ></el-button>
                        <el-button
                          type="text"
                          size="small"
                         icon="el-icon-arrow-up"
                        v-if="scope.row.SHOW_EDIT==1"
                          @click="handleEdit2(scope.$index, scope.row)"
                        ></el-button>
                      </p>
                    </div>
                    <div v-if="scope.row.SHOW_EDIT==1">
                  
                    <el-button
                      @click="handleClick_reb(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                   
                    <el-button
                      @click="handleClick2(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.ditt") }}
                    </el-button>
                   
                    <el-button
                      @click="handleClick3(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      v-if="scope.row.HAS_NOTIFY == 1"
                    >
                      {{ notify_mode }}
                    </el-button>
                    </div>-->
                  </template>
                </el-table-column>
                <!-- 策略规则-->

                <el-table-column prop="POLICY_RULE" :label="$t('logs.Policy_list4')">
                  <template slot-scope="scope">
                    <span
                      v-for="(v, i) in isClick(scope.row.POLICY_RULE)"
                      :key="i"
                      @click="rule_policy(v.bol, v.val)"
                      >{{ v.val }}</span
                    >
                  </template>
                </el-table-column>
                <!-- 组合策略-->

                <el-table-column
                  prop="COMB_RULE"
                  :label="$t('logs.Policy_list5')"
                  width="130"
                >
                  <template slot-scope="scope">
                    <span
                      v-for="(v, i) in isClick(scope.row.COMB_RULE)"
                      :key="i"
                      @click="rule_combine(v.bol, v.val, scope.row)"
                      >{{ v.val }}</span
                    >
                  </template>
                </el-table-column>
                <!-- 过滤动作-->

                <el-table-column
                  prop="SHOW_ACTION"
                  :label="$t('logs.Policy_list6')"
                  width="130"
                >
                </el-table-column>
                <!-- 备注说明-->

                <el-table-column
                  prop="DESCRIPTION"
                  :label="$t('logs.Policy_list7')"
                  width="110"
                >
                </el-table-column>
                <!-- 方向-->

                <el-table-column prop="SHOW_DIRECT" :label="$t('logs.Policy_list8')">
                </el-table-column>
                <!-- 激活-->

                <el-table-column prop="SHOW_ACTIVE" :label="$t('logs.Policy_list9')">
                  <template slot-scope="scope">
                    <span v-if="scope.row.ACTIVE == 0" style="color: #f00">{{
                      scope.row.SHOW_ACTIVE
                    }}</span>
                    <span v-else>{{ scope.row.SHOW_ACTIVE }}</span>
                  </template>
                </el-table-column>
                <!-- 中心节点运行-->

                <el-table-column
                  prop="SHOW_RUNONCENTER"
                  :label="$t('logs.Policy_list10')"
                  width="140"
                  v-if="this.RUN_ON_CENTER == 1"
                >
                </el-table-column>
                <!-- 离线规则禁用-->

                <el-table-column
                  prop="SHOW_DISOFFLINE"
                  :label="$t('logs.Policy_list11')"
                  width="140"
                  v-if="this.OFFLINE == 1"
                >
                </el-table-column>
                <!-- 允许设置不检查-->

                <el-table-column
                  prop="SHOW_CFGCHECK"
                  :label="$t('logs.Policy_list12')"
                  width="140"
                  v-if="this.CFGCHECK == 1"
                >
                </el-table-column>
                <!-- 策略类型-->

                <el-table-column prop="SHOW_TYPE" :label="$t('logs.Policy_list13')">
                </el-table-column>
                <!-- 优先级-->

                <el-table-column prop="PRIORITY" :label="$t('logs.Policy_list14')">
                </el-table-column>
                <!-- 到期时间-->

                <el-table-column prop="SHOW_EXPIRE" :label="$t('logs.Policy_list15')">
                </el-table-column>
                <!-- 创建时间-->

                <el-table-column
                  prop="UPDATETIME"
                  :label="$t('logs.Policy_list16')"
                  width="130"
                >
                </el-table-column>
              </el-table>
            </div>
            <!-- 添加 和编辑部分-->
            <div class="lie lie_add_role" v-if="this.table_role_add == 1">
              <div class="create_information" v-if="this.table_role_edit == 0">
                {{ $t("logs.Policy_list2") }}
              </div>
              <div class="create_information" v-if="this.table_role_edit == 1">
                {{ $t("logs.Policy_list17") }}
              </div>

              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.new_policy_name }}:
                  </div>
                  <div class="block block1">
                    <p
                      v-if="this.table_role_edit == 1"
                      style="
                        text-align: left;
                        color: #0e2c5e;
                        margin: 8px 0px;
                        border-bottom: 0;
                      "
                    >
                      {{ this.add_new_policy_name }}
                    </p>
                    <el-input
                      v-if="this.table_role_edit == 0"
                      v-model="policy_name"
                      :placeholder="this.policy_comb_name_hint"
                    ></el-input>
                  </div>
                </div>
                <!-- 策略规则 -->
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.new_policy_rule }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="policy_rule"
                      clearable
                      :placeholder="this.policy_comb_explam"
                    ></el-input>
                    <el-select
                      v-model="policy_rule_select"
                      clearable
                      filterable
                      placeholder
                      @change="add_policy_rule"
                      style="margin-left: 10px; width: 140px"
                    >
                      <el-option
                        v-for="item in policy_rule_select_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <!-- 策略规则 -->

                <div class="find1" v-if="this.new_comb_rule_show == 1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.new_comb_rule }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="comb_rule" :placeholder="this.policy_comb_explam" clearable></el-input>
                    <el-select
                      v-model="select_combrule"
                      clearable
                      placeholder
                      filterable
                      style="margin-left: 10px; width: 140px"
                      @change="add_comb_rule"
                    >
                      <el-option
                        v-for="item in select_combrule_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 备注说明 -->

                    {{ $t("logs.Policy_unit5") }} :
                  </div>
                  <div class="block block1">
                    <el-input v-model="description" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 优先级-->
                    {{ this.priority }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="priority1"></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 启用策略到期日期 -->

                    {{ $t("logs.Policy_comb9") }} :
                  </div>

                  <div class="block block1" style="display: flex; align-items: center">
                    <el-checkbox v-model="chkexpire"></el-checkbox>
                    <el-date-picker
                      v-model="expire"
                      type="date"
                      placeholder=""
                      style="padding-right: 0px"
                      :picker-options="pickerOptions"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 激活 -->

                    {{ $t("logs.Policy_comb5") }}
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="active">
                      <el-radio :label="1">{{ $t("logs.Policy_comb12") }}</el-radio>
                      <el-radio :label="0">{{ $t("logs.Policy_comb13") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <!-- 激活 -->
                <div class="find1" v-if="this.manself_show == 1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.manself_text }}
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="manself">
                      <el-radio :label="1">{{ $t("logs.Policy_comb12") }}</el-radio>
                      <el-radio :label="0">{{ $t("logs.Policy_comb13") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="find1" v-if="this.RUN_ON_CENTER == 1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 中心节点运行 -->
                    {{ $t("logs.Policy_list10") }}:
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="runoncenter">
                      <el-radio :label="1">{{ $t("logs.Policy_comb12") }}</el-radio>
                      <el-radio :label="0">{{ $t("logs.Policy_comb13") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="find1" v-if="this.OFFLINE == 1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.disableatoffline1 }}:
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="disableatoffline">
                      <el-radio :label="1">{{ $t("logs.Policy_comb12") }}</el-radio>
                      <el-radio :label="0">{{ $t("logs.Policy_comb13") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="find1" v-if="this.CFGCHECK == 1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 允许设置不检查 -->
                    {{ $t("logs.Policy_list12") }}:
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="cfgcheck">
                      <el-radio :label="1">{{ $t("logs.Policy_comb12") }}</el-radio>
                      <el-radio :label="0">{{ $t("logs.Policy_comb13") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 方向 -->
                    {{ $t("logs.Policy_list8") }} :
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="direct">
                      <el-radio :label="1">{{ $t("logs.group7_a11") }}</el-radio>
                      <el-radio :label="2">{{ $t("logs.group7_a12") }}</el-radio>
                      <el-radio :label="3">{{ $t("logs.group7_a8") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <!-- 策略类型 -->
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_list13") }} :
                  </div>
                  <div class="block block1">
                    <el-select v-model="policy_type" placeholder="请选择">
                      <el-option
                        v-for="item in policy_type_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <!-- 过滤动作 -->
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_list6") }} :
                  </div>

                  <div class="block block1" style="display: flex; align-items: center">
                    <el-select
                      v-model="policy_action"
                      placeholder="请选择"
                      @change="change_action"
                    >
                      <el-option
                        v-for="item in policy_action_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <img
                      src="/imgs/explain.png"
                      alt=""
                      @click="drawer = true"
                      style="
                        width: 20px;
                        height: 20px;
                        cursor: pointer;
                        margin-left: 10px;
                      "
                      v-if="this.has_policy_route == true"
                    />
                  </div>
                </div>
                 <div class="find1" v-if="this.has_notify == true">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 通知地址-->
                    {{ this.notify_email }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="policy_nto"
                      :placeholder="this.multi_address_hint"
                    ></el-input>
                  </div>
                </div>
                <!-- 通知设置 -->
                <div class="find1" v-if="this.has_notice_tem == true">
                  <div class="find-text" style="padding-right: 12px; width: 24.9%">
                    {{ this.notify_mode }}:
                  </div>
                  <div class="block block1 notice_the_template_warp" v-loading="loading_tempalte">
                       <div class="notice_the_template">
                      <div class="find-text" style="padding-right: 12px">
                        <!-- 模板选择-->
                        {{ this.select_notify_template }}:
                      </div>
                      <div class="block block1">
                          <el-select
                      v-model="template_name"
                      placeholder="请选择"
                      @change="change_template"
                    >
                      <el-option
                        v-for="item in tempalte_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                      </div>
                    </div>
                    <div class="notice_the_template">
                      <div class="find-text" style="padding-right: 12px">
                        <!-- 发件人-->
                        {{ this.envfrom1 }}:
                      </div>
                      <div class="block block1">
                        <el-input v-model="notify_envfrom"></el-input>
                      </div>
                    </div>
                    <div class="notice_the_template">
                      <div class="find-text" style="padding-right: 12px">
                        <!-- 通知主题-->
                        {{ this.notify_subject1 }}:
                      </div>
                      <div class="block block1">
                        <el-input v-model="notify_subject"></el-input>
                      </div>
                    </div>
                    <div class="notice_the_template">
                      <div class="find-text" style="padding-right: 12px">
                        <!-- 通知内容-->
                        {{ this.notify_body1 }}:
                      </div>
                      <div class="block block1" style="padding: 10px 0 10px 10px">
                        <el-input
                          type="textarea"
                          :autosize="{ minRows: 2, maxRows: 4 }"
                          placeholder="请输入内容"
                          v-model="notify_body_template"
                        >
                        </el-input>
                      </div>
                    </div>

                    <div class="notice_the_template">
                      <div class="find-text" style="padding-right: 12px">
                        <!-- 原邮件作为附件 -->

                        {{ this.notify_inc_eml1 }}:
                      </div>

                      <div
                        class="block block1"
                        style="display: flex; align-items: center"
                      >
                        <el-checkbox
                          v-model="notify_inc_eml"
                          style="padding: 12px 0"
                        ></el-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 转发-->

                <div class="find1" v-if="this.has_fwd == true">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.fwd_email }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="policy_fwd"
                      :placeholder="this.multi_address_hint"
                    ></el-input>
                  </div>
                </div>
                <div class="find1" v-if="this.has_cc == true">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 抄送地址-->
                    {{ this.cc_email }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="policy_cc"
                      :placeholder="this.multi_address_hint"
                    ></el-input>
                  </div>
                </div>

                <div class="find1" v-if="this.has_defer == true">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 延迟投递时间-->
                    {{ this.defer_time1 }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="defer_time"
                      :placeholder="this.alert_rate_minute"
                    ></el-input>
                  </div>
                </div>
                
               
                <div class="find1" v-if="this.has_addsub == true">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 标题前缀-->
                    {{ this.subflag }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="policy_addsub"
                      :placeholder="this.addsub_hint"
                    ></el-input>
                  </div>
                </div>

                <div class="find1" v-if="this.has_policy_route == true">
                  <div
                    class=""
                    style="
                      padding-right: 12px;
                      display: flex;
                      align-items: center;
                      padding: 10px 0;
                      width: 100%;
                    "
                  >
                    <!-- 设置ip地址或域名 v-if="this.ip_domain_show==1"  {{ this.ip_domain_text }}-->

                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 3 }"
                      placeholder="请输入内容"
                      v-model="policy_route_json_str"
                      style="width: 100%; margin: 0px 10px"
                      wrap="off"
                    >
                    </el-input>
                  </div>
                </div>
                  <div class="find1" v-show="this.has_timer_rdefer==true" >
                  <div class="find-text" style="padding-right: 12px">
                  {{this.timedefer_hint_show}}:
                  </div>
                  <div class="block block1">
                   <span class="find-text">{{ $t("logs.Policy_list24") }}：</span> 
                   <el-input
                      v-model="timer_hour"
                      placeholder=""
                      oninput="value=value.replace(/[^\d]/g,'')"
                      clearable
                      maxlength="5"
                      style="width: 100px"
                    ></el-input>
                     <span class="find-text"> {{ $t("logs.Policy_list25") }}：</span> 
                    <el-input
                      v-model="timer_min"
                      placeholder=""
                      oninput="value=value.replace(/[^\d]/g,'')"
                      clearable
                      maxlength="5"
                      style="width: 100px"
                    ></el-input>
                  </div>
                </div>
       
                <!-- 保存时间 -->

                <div class="find1" v-if="this.policy_priv_show == 1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_list22") }}:
                  </div>
                  <div class="block block1">
                    <el-radio v-model="radio_saveday" label="0">{{
                      $t("logs.group7_a9")
                    }}</el-radio>
                    <el-radio
                      v-model="radio_saveday"
                      label="1"
                      style="margin-right: 10px"
                    >
                      {{ $t("logs.Policy_list23") }}</el-radio
                    >
                    <el-input
                      v-model="save_day"
                      placeholder=""
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      clearable
                      maxlength="5"
                      style="width: 100px"
                    ></el-input>
                  </div>
                </div>
                <!-- 策略权限 -->
                <div class="find1" v-if="this.policy_priv_show == 1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_list19") }} :
                  </div>
                  <div class="block block1" s>
                    <el-checkbox
                      :indeterminate="isIndeterminate"
                      v-model="checkAll"
                      @change="handleCheckAllChange"
                      style="padding: 6px 0"
                      >{{ $t("logs.report13") }}</el-checkbox
                    >

                    <el-checkbox-group
                      v-model="checkedCities"
                      @change="handleCheckedCitiesChange"
                      style="display: flex; flex-wrap: wrap; padding-bottom: 6px"
                    >
                      <el-checkbox
                        v-for="v in policy_priv_add_edit"
                        :label="v.key"
                        :key="v.key"
                        class="policy_priv_role"
                        >{{ v.label }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px"></div>
                  <div class="block block1">
                    <el-button type="primary" @click="save_policy()">{{
                      $t("tab.save")
                    }}</el-button>

                    <el-button type="danger" @click="off_policy()">{{
                      $t("tab.cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
            <!-- 抽屉部分 -->
            <el-drawer
              title="我是标题"
              :visible.sync="drawer"
              :modal="false"
              direction="ttb"
              :with-header="false"
            >
              <p v-html="this.routing_setup_instructions" style="padding: 5px 20px"></p>
            </el-drawer>
            <!-- 编辑 -->

            <div class="gray" v-show="tanchu_edit"></div>
            <!-- 通知设置 -->
            <div
              class="pop-up"
              v-show="tanchu_setting"
              v-drag="{ handle: '.pop_up_text_relay_domain_edit' }"
            >
              <div class="pop_up_text pop_up_text_relay_domain_edit">
                <span class="span_pad"></span>{{ this.notify_mode }}
              </div>

              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.new_policy_name1 }}:
                  </div>
                  <div class="block block1">
                    <p
                      style="
                        text-align: left;
                        color: #0e2c5e;
                        margin: 8px 0px;
                        border-bottom: 0;
                      "
                    >
                      {{ this.add_new_policy_name }}
                    </p>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 发件人-->
                    {{ this.envfrom1 }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="notify_envfrom"></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 通知主题-->
                    {{ this.notify_subject1 }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="notify_subject"></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 通知内容-->
                    {{ this.notify_body1 }}:
                  </div>
                  <div class="block block1" style="margin: 10px 0">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      placeholder="请输入内容"
                      v-model="notify_body_template"
                    >
                    </el-input>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 原邮件作为附件 -->

                    {{ this.notify_inc_eml1 }}:
                  </div>

                  <div class="block block1" style="display: flex; align-items: center">
                    <el-checkbox v-model="notify_inc_eml"></el-checkbox>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_policy_setting()">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="tanOff_setting()">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_setting"></div>
          </div>
        </el-tab-pane>
          <!--  超级白名单策略 -->
        <el-tab-pane label="">
          <span slot="label">{{ $t("logs.Policy_list_white") }}</span>
          <div class="main" v-if="this.table_role_show == 1">
            <p>
              <el-button
                @click="add_role_show()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.Policy_list2") }}</el-button
              >
            </p>
          </div>
          <div class="switch1">
            <div class="table table_hover" v-if="this.table_role_show == 1">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList"
                :row-class-name="tableRowClassName"
                class="table-fixed"
                v-loading="loading"
              >
                <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="60">
                </el-table-column>
                <!-- 策略名称 -->

                <el-table-column
                  prop="POLICY_NAME"
                  :label="$t('logs.Policy_list3')"
                  width="126"
                >
                  <template slot-scope="scope">
                    <el-popover placement="left" visible-arrow="false" trigger="hover">
                      <el-button slot="reference" type="text" size="small">{{
                        scope.row.POLICY_NAME
                      }}</el-button>
                      <div>
                        <!-- 删除-->
                        <el-button
                          @click="handleClick_reb(scope.$index, scope.row)"
                          type="text"
                          size="small"
                          :disabled="$root.jurisdiction.only_query == 0"
                        >
                          {{ $t("table1.delete") }}
                        </el-button>
                        <!-- 编辑-->
                        <el-button
                          @click="handleClick2(scope.$index, scope.row)"
                          type="text"
                          size="small"
                          :disabled="$root.jurisdiction.only_query == 0"
                        >
                          {{ $t("table1.ditt") }}
                        </el-button>
                        <!-- 通知设置-->
                        <!-- <el-button
                          @click="handleClick3(scope.$index, scope.row)"
                          type="text"
                          size="small"
                          v-if="scope.row.HAS_NOTIFY == 1"
                          :disabled="$root.jurisdiction.only_query == 0"
                        >
                          {{ notify_mode }}
                        </el-button> -->
                      </div>
                    </el-popover>
                    <!-- 下拉箭头删除-->
                    <!--     <div>
                      <p>
                        {{
                          scope.row.POLICY_NAME 
                        }}
                       
                        <el-button
                          type="text"
                          size="small"
                         icon="el-icon-arrow-down"
                        v-if="scope.row.SHOW_EDIT==0"
                          @click="handleEdit1(scope.$index, scope.row)"
                        ></el-button>
                        <el-button
                          type="text"
                          size="small"
                         icon="el-icon-arrow-up"
                        v-if="scope.row.SHOW_EDIT==1"
                          @click="handleEdit2(scope.$index, scope.row)"
                        ></el-button>
                      </p>
                    </div>
                    <div v-if="scope.row.SHOW_EDIT==1">
                  
                    <el-button
                      @click="handleClick_reb(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                   
                    <el-button
                      @click="handleClick2(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.ditt") }}
                    </el-button>
                   
                    <el-button
                      @click="handleClick3(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      v-if="scope.row.HAS_NOTIFY == 1"
                    >
                      {{ notify_mode }}
                    </el-button>
                    </div>-->
                  </template>
                </el-table-column>
                <!-- 策略规则-->

                <el-table-column prop="POLICY_RULE" :label="$t('logs.Policy_list4')">
                  <template slot-scope="scope">
                    <span
                      v-for="(v, i) in isClick(scope.row.POLICY_RULE)"
                      :key="i"
                      @click="rule_policy(v.bol, v.val)"
                      >{{ v.val }}</span
                    >
                  </template>
                </el-table-column>
                <!-- 组合策略-->

                <el-table-column
                  prop="COMB_RULE"
                  :label="$t('logs.Policy_list5')"
                  width="130"
                >
                  <template slot-scope="scope">
                    <span
                      v-for="(v, i) in isClick(scope.row.COMB_RULE)"
                      :key="i"
                      @click="rule_combine(v.bol, v.val, scope.row)"
                      >{{ v.val }}</span
                    >
                  </template>
                </el-table-column>
                <!-- 过滤动作-->

                <el-table-column
                  prop="SHOW_ACTION"
                  :label="$t('logs.Policy_list6')"
                  width="130"
                >
                </el-table-column>
                <!-- 备注说明-->

                <el-table-column
                  prop="DESCRIPTION"
                  :label="$t('logs.Policy_list7')"
                  width="110"
                >
                </el-table-column>
                <!-- 方向-->

                <el-table-column prop="SHOW_DIRECT" :label="$t('logs.Policy_list8')">
                </el-table-column>
                <!-- 激活-->

                <el-table-column prop="SHOW_ACTIVE" :label="$t('logs.Policy_list9')">
                  <template slot-scope="scope">
                    <span v-if="scope.row.ACTIVE == 0" style="color: #f00">{{
                      scope.row.SHOW_ACTIVE
                    }}</span>
                    <span v-else>{{ scope.row.SHOW_ACTIVE }}</span>
                  </template>
                </el-table-column>
                <!-- 中心节点运行-->

                <!-- <el-table-column
                  prop="SHOW_RUNONCENTER"
                  :label="$t('logs.Policy_list10')"
                  width="140"
                  v-if="this.RUN_ON_CENTER == 1"
                >
                </el-table-column> -->
                <!-- 离线规则禁用-->

                <!-- <el-table-column
                  prop="SHOW_DISOFFLINE"
                  :label="$t('logs.Policy_list11')"
                  width="140"
                  v-if="this.OFFLINE == 1"
                >
                </el-table-column> -->
                <!-- 允许设置不检查-->
<!-- 
                <el-table-column
                  prop="SHOW_CFGCHECK"
                  :label="$t('logs.Policy_list12')"
                  width="140"
                  v-if="this.CFGCHECK == 1"
                >
                </el-table-column> -->
                <!-- 策略类型-->
<!-- 
                <el-table-column prop="SHOW_TYPE" :label="$t('logs.Policy_list13')">
                </el-table-column> -->
                <!-- 优先级-->

                <el-table-column prop="PRIORITY" :label="$t('logs.Policy_list14')">
                </el-table-column>
                <!-- 到期时间-->

                <el-table-column prop="SHOW_EXPIRE" :label="$t('logs.Policy_list15')">
                </el-table-column>
                <!-- 创建时间-->

                <el-table-column
                  prop="UPDATETIME"
                  :label="$t('logs.Policy_list16')"
                  width="130"
                >
                </el-table-column>
              </el-table>
            </div>
            <!-- 添加 和编辑部分-->
            <div class="lie lie_add_role" v-if="this.table_role_add == 1">
              <div class="create_information" v-if="this.table_role_edit == 0">
                {{ $t("logs.Policy_list2") }}
              </div>
              <div class="create_information" v-if="this.table_role_edit == 1">
                {{ $t("logs.Policy_list17") }}
              </div>

              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.new_policy_name }}:
                  </div>
                  <div class="block block1">
                    <p
                      v-if="this.table_role_edit == 1"
                      style="
                        text-align: left;
                        color: #0e2c5e;
                        margin: 8px 0px;
                        border-bottom: 0;
                      "
                    >
                      {{ this.add_new_policy_name }}
                    </p>
                    <el-input
                      v-if="this.table_role_edit == 0"
                      v-model="policy_name"
                      :placeholder="this.policy_comb_name_hint"
                    ></el-input>
                  </div>
                </div>
                <!-- 策略规则 -->
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.new_policy_rule }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="policy_rule"
                      clearable
                      :placeholder="this.policy_comb_explam"
                    ></el-input>
                    <el-select
                      v-model="policy_rule_select"
                      clearable
                      filterable
                      placeholder
                      @change="add_policy_rule"
                      style="margin-left: 10px; width: 140px"
                    >
                      <el-option
                        v-for="item in policy_rule_select_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <!-- 策略规则 -->

                <div class="find1" v-if="this.new_comb_rule_show == 1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.new_comb_rule }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="comb_rule" :placeholder="this.policy_comb_explam" clearable></el-input>
                    <el-select
                      v-model="select_combrule"
                      clearable
                      placeholder
                      filterable
                      style="margin-left: 10px; width: 140px"
                      @change="add_comb_rule"
                    >
                      <el-option
                        v-for="item in select_combrule_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 备注说明 -->

                    {{ $t("logs.Policy_unit5") }} :
                  </div>
                  <div class="block block1">
                    <el-input v-model="description" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 优先级-->
                    {{ this.priority }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="priority1"></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 启用策略到期日期 -->

                    {{ $t("logs.Policy_comb9") }} :
                  </div>

                  <div class="block block1" style="display: flex; align-items: center">
                    <el-checkbox v-model="chkexpire"></el-checkbox>
                    <el-date-picker
                      v-model="expire"
                      type="date"
                      placeholder=""
                      style="padding-right: 0px"
                      :picker-options="pickerOptions"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 激活 -->

                    {{ $t("logs.Policy_comb5") }}
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="active">
                      <el-radio :label="1">{{ $t("logs.Policy_comb12") }}</el-radio>
                      <el-radio :label="0">{{ $t("logs.Policy_comb13") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <!-- 隔离 -->
                <!-- <div class="find1" v-if="this.manself_show == 1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.manself_text }}
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="manself">
                      <el-radio :label="1">{{ $t("logs.Policy_comb12") }}</el-radio>
                      <el-radio :label="0">{{ $t("logs.Policy_comb13") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div> -->
                    <!-- 中心节点运行 -->

                <!-- <div class="find1" v-if="this.RUN_ON_CENTER == 1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_list10") }}:
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="runoncenter">
                      <el-radio :label="1">{{ $t("logs.Policy_comb12") }}</el-radio>
                      <el-radio :label="0">{{ $t("logs.Policy_comb13") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div> -->
                <!-- <div class="find1" v-if="this.OFFLINE == 1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.disableatoffline1 }}:
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="disableatoffline">
                      <el-radio :label="1">{{ $t("logs.Policy_comb12") }}</el-radio>
                      <el-radio :label="0">{{ $t("logs.Policy_comb13") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div> -->
                    <!-- 允许设置不检查 -->
<!-- 
                <div class="find1" v-if="this.CFGCHECK == 1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_list12") }}:
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="cfgcheck">
                      <el-radio :label="1">{{ $t("logs.Policy_comb12") }}</el-radio>
                      <el-radio :label="0">{{ $t("logs.Policy_comb13") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div> -->

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 方向 -->
                    {{ $t("logs.Policy_list8") }} :
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="direct">
                      <el-radio :label="1">{{ $t("logs.group7_a11") }}</el-radio>
                      <el-radio :label="2">{{ $t("logs.group7_a12") }}</el-radio>
                      <el-radio :label="3">{{ $t("logs.group7_a8") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <!-- 策略类型 -->
                <!-- <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_list13") }} :
                  </div>
                  <div class="block block1">
                    <el-select v-model="policy_type" placeholder="请选择">
                      <el-option
                        v-for="item in policy_type_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div> -->
                <!-- 过滤动作 -->
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_list6") }} :
                  </div>

                  <div class="block block1" style="display: flex; align-items: center">
                    <el-select
                      v-model="policy_action"
                      placeholder="请选择"
                      @change="change_action"
                    >
                      <el-option
                        v-for="item in policy_action_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <img
                      src="/imgs/explain.png"
                      alt=""
                      @click="drawer = true"
                      style="
                        width: 20px;
                        height: 20px;
                        cursor: pointer;
                        margin-left: 10px;
                      "
                      v-if="this.has_policy_route == true"
                    />
                  </div>
                </div>
                 <div class="find1" v-if="this.has_notify == true">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 通知地址-->
                    {{ this.notify_email }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="policy_nto"
                      :placeholder="this.multi_address_hint"
                    ></el-input>
                  </div>
                </div>
                <!-- 通知设置 -->
                <div class="find1" v-if="this.has_notice_tem == true">
                  <div class="find-text" style="padding-right: 12px; width: 24.9%">
                    {{ this.notify_mode }}:
                  </div>
                  <div class="block block1 notice_the_template_warp" v-loading="loading_tempalte">
                       <div class="notice_the_template">
                      <div class="find-text" style="padding-right: 12px">
                        <!-- 模板选择-->
                        {{ this.select_notify_template }}:
                      </div>
                      <div class="block block1">
                          <el-select
                      v-model="template_name"
                      placeholder="请选择"
                      @change="change_template"
                    >
                      <el-option
                        v-for="item in tempalte_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                      </div>
                    </div>
                    <div class="notice_the_template">
                      <div class="find-text" style="padding-right: 12px">
                        <!-- 发件人-->
                        {{ this.envfrom1 }}:
                      </div>
                      <div class="block block1">
                        <el-input v-model="notify_envfrom"></el-input>
                      </div>
                    </div>
                    <div class="notice_the_template">
                      <div class="find-text" style="padding-right: 12px">
                        <!-- 通知主题-->
                        {{ this.notify_subject1 }}:
                      </div>
                      <div class="block block1">
                        <el-input v-model="notify_subject"></el-input>
                      </div>
                    </div>
                    <div class="notice_the_template">
                      <div class="find-text" style="padding-right: 12px">
                        <!-- 通知内容-->
                        {{ this.notify_body1 }}:
                      </div>
                      <div class="block block1" style="padding: 10px 0 10px 10px">
                        <el-input
                          type="textarea"
                          :autosize="{ minRows: 2, maxRows: 4 }"
                          placeholder="请输入内容"
                          v-model="notify_body_template"
                        >
                        </el-input>
                      </div>
                    </div>

                    <div class="notice_the_template">
                      <div class="find-text" style="padding-right: 12px">
                        <!-- 原邮件作为附件 -->

                        {{ this.notify_inc_eml1 }}:
                      </div>

                      <div
                        class="block block1"
                        style="display: flex; align-items: center"
                      >
                        <el-checkbox
                          v-model="notify_inc_eml"
                          style="padding: 12px 0"
                        ></el-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 转发-->

                <div class="find1" v-if="this.has_fwd == true">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.fwd_email }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="policy_fwd"
                      :placeholder="this.multi_address_hint"
                    ></el-input>
                  </div>
                </div>
                <div class="find1" v-if="this.has_cc == true">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 抄送地址-->
                    {{ this.cc_email }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="policy_cc"
                      :placeholder="this.multi_address_hint"
                    ></el-input>
                  </div>
                </div>

                <div class="find1" v-if="this.has_defer == true">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 延迟投递时间-->
                    {{ this.defer_time1 }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="defer_time"
                      :placeholder="this.alert_rate_minute"
                    ></el-input>
                  </div>
                </div>
                
               
                <div class="find1" v-if="this.has_addsub == true">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 标题前缀-->
                    {{ this.subflag }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="policy_addsub"
                      :placeholder="this.addsub_hint"
                    ></el-input>
                  </div>
                </div>

                <div class="find1" v-if="this.has_policy_route == true">
                  <div
                    class=""
                    style="
                      padding-right: 12px;
                      display: flex;
                      align-items: center;
                      padding: 10px 0;
                      width: 100%;
                    "
                  >
                    <!-- 设置ip地址或域名 v-if="this.ip_domain_show==1"  {{ this.ip_domain_text }}-->

                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 3 }"
                      placeholder="请输入内容"
                      v-model="policy_route_json_str"
                      style="width: 100%; margin: 0px 10px"
                      wrap="off"
                    >
                    </el-input>
                  </div>
                </div>
                  <div class="find1" v-show="this.has_timer_rdefer==true" >
                  <div class="find-text" style="padding-right: 12px">
                  {{this.timedefer_hint_show}}:
                  </div>
                  <div class="block block1">
                   <span class="find-text">{{ $t("logs.Policy_list24") }}：</span> 
                   <el-input
                      v-model="timer_hour"
                      placeholder=""
                      oninput="value=value.replace(/[^\d]/g,'')"
                      clearable
                      maxlength="5"
                      style="width: 100px"
                    ></el-input>
                     <span class="find-text"> {{ $t("logs.Policy_list25") }}：</span> 
                    <el-input
                      v-model="timer_min"
                      placeholder=""
                      oninput="value=value.replace(/[^\d]/g,'')"
                      clearable
                      maxlength="5"
                      style="width: 100px"
                    ></el-input>
                  </div>
                </div>
                              <!-- 可选动作 -->

                    <div class="find1">
                  <div class="find-text" style="padding-right: 12px">

                    {{ $t("logs.Policy_comb_select") }} :
                  </div>

                  <div
                    class="block block1"
                    style="display: flex; align-items: center;"
                  >
                    <el-checkbox v-model="option_select" style="margin-right:10px"></el-checkbox>
                    <el-select
                      v-model="option_action"
                      placeholder="请选择"
                      @change="change_action_option"
                    >
                      <el-option
                        v-for="item in option_action_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                   <!-- 抄送地址-->

                <div class="find1" v-show="this.has_cc_option">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.cc_email }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="option_policy_cc"
                      :placeholder="this.multi_address_hint"
                    ></el-input>
                  </div>
                </div>
                <!-- end -->
                <!-- 保存时间 -->

                <!-- <div class="find1" v-if="this.policy_priv_show == 1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_list22") }}:
                  </div>
                  <div class="block block1">
                    <el-radio v-model="radio_saveday" label="0">{{
                      $t("logs.group7_a9")
                    }}</el-radio>
                    <el-radio
                      v-model="radio_saveday"
                      label="1"
                      style="margin-right: 10px"
                    >
                      {{ $t("logs.Policy_list23") }}</el-radio
                    >
                    <el-input
                      v-model="save_day"
                      placeholder=""
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      clearable
                      maxlength="5"
                      style="width: 100px"
                    ></el-input>
                  </div>
                </div> -->
                <!-- 策略权限 -->
                <!-- <div class="find1" v-if="this.policy_priv_show == 1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_list19") }} :
                  </div>
                  <div class="block block1" s>
                    <el-checkbox
                      :indeterminate="isIndeterminate"
                      v-model="checkAll"
                      @change="handleCheckAllChange"
                      style="padding: 6px 0"
                      >{{ $t("logs.report13") }}</el-checkbox
                    >

                    <el-checkbox-group
                      v-model="checkedCities"
                      @change="handleCheckedCitiesChange"
                      style="display: flex; flex-wrap: wrap; padding-bottom: 6px"
                    >
                      <el-checkbox
                        v-for="v in policy_priv_add_edit"
                        :label="v.key"
                        :key="v.key"
                        class="policy_priv_role"
                        >{{ v.label }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </div>
                </div> -->
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px"></div>
                  <div class="block block1">
                    <el-button type="primary" @click="save_policy()">{{
                      $t("tab.save")
                    }}</el-button>

                    <el-button type="danger" @click="off_policy()">{{
                      $t("tab.cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
            <!-- 抽屉部分 -->
            <el-drawer
              title="我是标题"
              :visible.sync="drawer"
              :modal="false"
              direction="ttb"
              :with-header="false"
            >
              <p v-html="this.routing_setup_instructions" style="padding: 5px 20px"></p>
            </el-drawer>
           
          </div>
        </el-tab-pane>
      </el-tabs>
      <!-- 策略名称 ,过滤策略-->
      <div v-show="xian2" v-loading="loading">
        <div class="main1">
          <div class="create_information" v-if="this.xian3 == 0">
            {{ $t("logs.filter2") }}
          </div>
          <div class="create_information" v-if="this.xian3 == 1">
            {{ $t("logs.filter10") }}
          </div>
          <el-button
            type="primary"
            @click="tan_showmacro()"
            v-show="showmacro_list1"
            v-if="this.show_macro_list == 1"
            >{{ $t("logs.filter8") }}</el-button
          >
          <el-button type="primary" @click="tan_showmacro1()" v-show="showmacro_list">{{
            $t("logs.filter9")
          }}</el-button>
        </div>
        <div class="lie" v-show="showmacro_list">
          <table>
            <tbody>
              <tr v-for="v in showmacro" :key="v.id">
                <td>{{ v.MACRO_NAME }}</td>
                <td style="padding: 10px 0 10px 20px">
                  {{ v.MACRO_VALUE }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="lie">
          <table>
            <tbody>
              <tr>
                <!--  过滤器名称-->
                <td>{{ $t("logs.filter3") }}:</td>
                <td>
                  <el-input
                    v-model="filter_name"
                    placeholder
                    v-if="this.xian3 == 0"
                  ></el-input>
                  <span
                    style="text-align: left; color: #0e2c5e; line-height: 32px"
                    v-if="this.xian3 == 1"
                    >{{ this.filter_name }}</span
                  >
                </td>
              </tr>
              <tr>
                <!--  过滤器描述-->

                <td>{{ $t("logs.filter4") }}:</td>
                <td>
                  <el-input v-model="filter_describe" placeholder></el-input>
                </td>
              </tr>
            </tbody>
            <!--  启用条件策略-->

            <tbody>
              <tr>
                <!--  启用条件策略-->

                <td>{{ $t("logs.Conditional1") }}:</td>
                <td style="display: flex; flex-direction: row">
                  <el-checkbox v-model="chkcondition" @change="change"></el-checkbox>
                  <el-radio-group
                    v-model="rootcondrelation"
                    style="padding-left: 20px"
                    @change="change1"
                  >
                    <el-radio :label="1">
                      {{ $t("logs.Conditional2") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Conditional3") }}
                    </el-radio>
                  </el-radio-group>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <div class="tiaojian_a" v-for="v in tiaoa" :key="v.id">
                    <ul>
                      <!--  条件块-->

                      <li>{{ $t("logs.Conditional4") }}:</li>
                      <!--  添加条件块-->

                      <li @click="tiaojian_add1" class="cursor_hover">
                        {{ $t("logs.Conditional5") }}
                      </li>
                      <!--  删除条件块-->

                      <li @click="deleteRow(v.id)" class="cursor_hover">
                        {{ $t("logs.Conditional6") }}
                      </li>
                      <li>
                        <el-radio-group
                          v-model="v.condition_relation"
                          style="padding-left: 20px"
                        >
                          <el-radio :label="1">
                            {{ $t("logs.Conditional2") }}
                          </el-radio>
                          <el-radio :label="0">
                            {{ $t("logs.Conditional3") }}
                          </el-radio>
                        </el-radio-group>
                      </li>
                    </ul>
                    <ol v-for="c in v.tiaob" :key="c.id">
                      <el-select
                        v-model="c.condition_name"
                        style="width: 150px"
                        v-show="condition_judge1(c.condition_name)"
                      >
                        <el-option
                          v-for="item in condition_namee0"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-select
                        v-model="c.msgsize_type"
                        style="width: 90px"
                        v-show="condition_judge2(c.condition_name)"
                      >
                        <el-option
                          v-for="item in msgsize_typee0"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!-- 只有大于，没有小于-->
                      <el-select
                        v-model="c.msgsize_type"
                        style="width: 90px"
                        v-show="condition_judge_big(c.condition_name)"
                      >
                        <el-option
                          v-for="item in sublen_typee"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-input
                        v-model="c.msgsize"
                        style="width: 40px"
                        v-show="condition_judge3(c.condition_name)"
                      ></el-input>
                      <el-select
                        v-model="c.msgsize_unit"
                        style="width: 54px"
                        v-show="condition_judge4(c.condition_name)"
                      >
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!--  当值为网络类型-->
                      <el-select
                        v-model="c.network_type"
                        style="width: 120px"
                        v-show="condition_judge5(c.condition_name)"
                      >
                        <el-option
                          v-for="item in network_type00"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!--  当值为是否为白名单-->
                      <el-select
                        v-model="c.white_type"
                        style="width: 50px"
                        v-show="condition_judge6(c.condition_name)"
                      >
                        <el-option
                          v-for="item in white_typee"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                           <!--  当值为是否为spf-->
                      <el-select
                        v-model="c.spf_result"
                        style="width: 100px"
                        v-show="condition_judge_spf(c.condition_name)"
                      >
                        <el-option
                          v-for="item in q_spf_result"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!--  添加-->

                      <li @click="tiaojian_add2(v.id)" class="cursor_hover">
                        {{ $t("logs.Conditional7") }}
                      </li>
                      <!--  删除-->

                      <li @click="deleteRow2(v.id, c.id)" class="cursor_hover">
                        {{ $t("logs.Conditional8") }}
                      </li>
                    </ol>
                  </div>
                </td>
              </tr>
            </tbody>
            <!--  启用内容策略-->
            <tbody>
              <tr>
                <!--  启用内容策略-->

                <td>{{ $t("logs.Content1") }}:</td>
                <td style="display: flex; flex-direction: row">
                  <el-checkbox v-model="chkcontent" @change="change3"></el-checkbox>
                  <el-radio-group
                    v-model="rootcontrelation"
                    @change="change4"
                    style="padding-left: 20px"
                  >
                    <el-radio :label="1">
                      {{ $t("logs.Conditional2") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Conditional3") }}
                    </el-radio>
                  </el-radio-group>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <div class="tiaojian_a" v-for="v in contentList" :key="v.id">
                    <ul>
                      <!--  内容块-->

                      <li>{{ $t("logs.Content2") }}:</li>
                      <!--  添加内容块-->

                      <li @click="content_add1" class="cursor_hover">
                        {{ $t("logs.Content3") }}
                      </li>
                      <!--  删除内容块-->

                      <li @click="deleteRow3(v.id)" class="cursor_hover">
                        {{ $t("logs.Content4") }}
                      </li>
                      <li>
                        <el-radio-group
                          v-model="v.content_out_relation"
                          style="padding-left: 20px"
                        >
                          <el-radio :label="1">
                            {{ $t("logs.Conditional2") }}
                          </el-radio>
                          <el-radio :label="0">
                            {{ $t("logs.Conditional3") }}
                          </el-radio>
                          <el-radio :label="2">
                            {{ $t("logs.Content5") }}
                          </el-radio>
                        </el-radio-group>
                      </li>
                    </ul>
                    <ol v-for="c in v.contentList1" :key="c.id" class="tiaojian_a_child">
                      <div class="content_keyword_fang">
                        <el-select
                          v-model="c.content_name"
                          style="width: 100px"
                          v-show="content_judge1(c.content_name, c.content_type)"
                        >
                          <el-option
                            v-for="item in content_namee0"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <!-- 内容策略原始信头 input-->
                        <el-input
                          v-model="c.header_key"
                          style="width: 80px"
                          v-show="content_judge2(c.content_name, c.content_type)"
                        ></el-input>
                        <!-- 内容策略原始信头 要求存在-->
                        <el-select
                          v-model="c.content_exist"
                          style="width: 120px"
                          v-show="content_judge3(c.content_name, c.content_type)"
                        >
                          <el-option
                            v-for="item in content_existt"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <!-- 包含不包含 -->
                        <el-select
                          v-model="c.content_relation"
                          style="width: 70px"
                          v-if="content_judge_keyword_or(c.content_name)"
                        >
                          <el-option
                            v-for="item in content_relationn0"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <!-- 包含不包含  关键字-->
                        <el-select
                          v-model="c.content_relation"
                          style="width: 70px"
                          v-if="content_judge_keyword(c.content_name)"
                        >
                          <el-option
                            v-for="item in content_relationn2"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <!-- 正则表达式    关键字-->
                        <el-select
                          v-model="c.content_type"
                          style="width: 94px"
                          v-if="content_judge_keyword_or(c.content_name)"
                        >
                          <el-option
                            v-for="item in content_typee0"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <!-- 正则表达式 keyword  -->
                        <el-select
                          v-model="c.content_type"
                          style="width: 94px"
                          v-if="content_judge_keyword(c.content_name)"
                        >
                          <el-option
                            v-for="item in content_typee2"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <!-- 分数 input-->
                        <el-input
                          v-model="c.score"
                          style="width: 40px"
                          v-show="content_judge_score(v.content_out_relation)"
                        >
                        </el-input>
                        <span
                          v-show="content_judge_score(v.content_out_relation)"
                          style="padding-left: 0"
                          >{{ $t("logs.point") }}</span
                        >
                        <!-- 邮件正文 多少次-->
                        <el-input
                          v-model="c.content_matchcn"
                          style="width: 40px"
                          v-show="content_judge4(c.content_name, c.content_type)"
                        ></el-input
                        ><span
                          v-show="content_judge4(c.content_name, c.content_type)"
                          style="padding-left: 0"
                          >{{ $t("logs.second_rate") }}</span
                        >
                        <!-- 内容策略ip，信封发件人，收件人  关键词，精准匹配-->
                        <el-select
                          v-model="c.content_match"
                          style="width: 120px"
                          v-show="content_judge5(c.content_name, c.content_type)"
                        >
                          <el-option
                            v-for="item in content_matchh"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <el-input
                          type="textarea"
                          placeholder=""
                          v-model="c.regex"
                          :autosize="{ minRows: 2, maxRows: 8 }"
                          resize="both"
                          style="width: 300px"
                        >
                        </el-input>
                        <!--  添加-->

                        <li @click="content_add2(v.id)" class="cursor_hover">
                          {{ $t("logs.Conditional7") }}
                        </li>
                        <!--  删除-->

                        <li @click="deleteRow4(v.id, c.id)" class="cursor_hover">
                          {{ $t("logs.Conditional8") }}
                        </li>
                      </div>
                      <div
                        class="content_keyword_fang_select"
                        v-if="content_judge_keyword(c.content_name)"
                      >
                        <el-checkbox-group
                          v-model="c.checkedCities"
                          @change="handleCheckedCitiesChange_role(c.checkedCities,c)"
                          style="display: flex; flex-wrap: wrap; padding-bottom: 6px"
                        >
                          <el-checkbox
                            v-for="v in policy_priv"
                            :label="v.value"
                            :key="v.value"
                            class="policy_priv_role"
                            >{{ v.label }}</el-checkbox
                          >
                        </el-checkbox-group>
                      </div>
                    </ol>
                  </div>
                </td>
              </tr>
            </tbody>
            <!--  启用A链接扫描-->
            <tbody>
              <tr>
                <!--  启用A链接扫描-->

                <td>{{ $t("logs.Alink1") }}:</td>
                <td style="display: flex; flex-direction: row">
                  <el-checkbox v-model="chkalink" @change="change5"></el-checkbox>
                  <el-radio-group
                    v-model="alink_out_relation"
                    @change="change6"
                    style="padding-left: 20px"
                  >
                    <el-radio :label="1">
                      {{ $t("logs.Conditional2") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Conditional3") }}
                    </el-radio>
                  </el-radio-group>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <div class="tiaojian_a" v-for="v in alinkList" :key="v.id">
                    <ul style="padding: 10px 0">
                      <!--  内容块-->

                      <li>{{ $t("logs.Alink2") }}:</li>
                      <!--  添加内容块-->

                      <li @click="alink_add1" class="cursor_hover">
                        {{ $t("logs.Alink3") }}
                      </li>
                      <!--  删除内容块-->

                      <li @click="deleteRow5(v.id)" class="cursor_hover">
                        {{ $t("logs.Alink4") }}
                      </li>
                    </ul>
                    <ol v-for="c in v.alinkList1" :key="c.id">
                      <el-select v-model="c.alink_name" style="width: 100px">
                        <el-option
                          v-for="item in alink_namee0"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-select v-model="c.alink_relation" style="width: 70px">
                        <el-option
                          v-for="item in alink_relationn0"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>

                      <el-select v-model="c.alink_type" style="width: 94px">
                        <el-option
                          v-for="item in alink_typee0"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 4 }"
                        placeholder=""
                        v-model="c.alink_regex"
                        resize="both"
                        style="width: 300px"
                      >
                      </el-input>
                      <!--  添加-->

                      <li @click="alink_add2(v.id)" class="cursor_hover"
                      >
                        {{ $t("logs.Conditional7") }}
                      </li>
                      <!--  删除-->

                      <li @click="deleteRow6(v.id, c.id)" class="cursor_hover">
                        {{ $t("logs.Conditional8") }}
                      </li>
                    </ol>
                  </div>
                </td>
              </tr>
            </tbody>

            <tbody>
              <tr>
                <td></td>
                <td style="display: flex; flex-direction: row">
                  <el-button type="primary" @click="save_filter_strategy()"  :disabled="$root.jurisdiction.only_query == 0">{{
                    $t("tab.save")
                  }}</el-button>
                  <el-button type="danger" @click="cancel_off()">{{
                    $t("tab.cancel")
                  }}</el-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- 发件人 -->
      <el-tabs v-show="tanchu_sender_all" v-loading="loading">
        <!-- 发件人 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.Policy_unit_sender1") }}</span>
          <div class="main">
            <el-button @click="save_sender_hide()">{{
              $t("logs.Policy_back")
            }}</el-button>
            <el-button @click="save_sender_show()"  :disabled="$root.jurisdiction.only_query == 0">{{
              $t("logs.Policy_unit_sender2")
            }}</el-button>
            <el-alert
              :title="this.show_hint"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="switch1">
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList2"
                :row-class-name="tableRowClassName"
              >
                <el-table-column prop="UNIT_NAME" :label="$t('logs.Policy_unit4')">
                </el-table-column>
                <el-table-column prop="DNOREMAIL" :label="$t('logs.Policy_unit_sender5')">
                </el-table-column>
                <el-table-column prop="SHOW_TYPE" :label="$t('logs.Policy_unit_sender6')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('table1.operation')">
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                     :disabled="$root.jurisdiction.only_query == 0"
                      @click="handleClick_sender(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu_sender" v-drag>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 过滤单元名称 -->
                    {{ $t("logs.Policy_unit4") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align: left; color: #0e2c5e">
                      {{ this.username }}
                    </p>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 域名或邮箱账号 -->
                    {{ $t("logs.notify7") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 4, maxRows: 8 }"
                      placeholder="一行一个地址"
                      v-model="users_sender"
                    >
                    </el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_sender">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_sender">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_sender"></div>
          </div>
        </el-tab-pane>
        <!-- 发件人 -->
        <el-tab-pane label=""> </el-tab-pane>
      </el-tabs>
      <!-- 收件人 -->
      <el-tabs v-show="tanchu_reciplent_all" v-loading="loading">
        <!-- 收件人 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.Policy_unit_Recipient1") }}</span>
          <div class="main">
            <el-button @click="save_reciplent_hide()">{{
              $t("logs.Policy_back")
            }}</el-button>
            <el-button @click="save_reciplent_show()"  :disabled="$root.jurisdiction.only_query == 0">{{
              $t("logs.Policy_unit_Recipient2")
            }}</el-button>
            <el-alert
              :title="this.show_hint"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="switch1">
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList2"
                :row-class-name="tableRowClassName"
              >
                <el-table-column prop="UNIT_NAME" :label="$t('logs.Policy_unit4')">
                </el-table-column>
                <el-table-column prop="DNOREMAIL" :label="$t('logs.Policy_unit_sender5')">
                </el-table-column>
                <el-table-column prop="SHOW_TYPE" :label="$t('logs.Policy_unit_sender6')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('table1.operation')">
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                     :disabled="$root.jurisdiction.only_query == 0"
                      @click="handleClick_sender(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu_reciplent" v-drag>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 过滤单元名称 -->
                    {{ $t("logs.Policy_unit4") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align: left; color: #0e2c5e">
                      {{ this.username }}
                    </p>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 域名或邮箱账号 -->
                    {{ $t("logs.notify7") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 4, maxRows: 8 }"
                      placeholder="一行一个地址"
                      v-model="users_reciplent"
                      style="margin: 8px 0"
                    >
                    </el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_reciplent">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_reciplent">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_reciplent"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label=""> </el-tab-pane>
      </el-tabs>
      <!-- ip地址 -->
      <el-tabs v-show="tanchu_ip_all" v-loading="loading">
        <!-- ip地址 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.Policy_unit_ip1") }}</span>
          <div class="main">
            <el-button @click="save_ip_hide()">{{ $t("logs.Policy_back") }}</el-button>
            <el-button @click="save_ip_show()"  :disabled="$root.jurisdiction.only_query == 0">{{
              $t("logs.Policy_unit_ip2")
            }}</el-button>
            <el-alert
              :title="this.show_hint"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="switch1">
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList2"
                :row-class-name="tableRowClassName"
              >
                <el-table-column prop="UNIT_NAME" :label="$t('logs.Policy_unit4')">
                </el-table-column>
                <el-table-column prop="DNOREMAIL" :label="$t('logs.Policy_unit_sender5')">
                </el-table-column>
                <el-table-column prop="SHOW_TYPE" :label="$t('logs.Policy_unit_sender6')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('table1.operation')">
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                     :disabled="$root.jurisdiction.only_query == 0"
                      @click="handleClick_sender(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu_ip" v-drag>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 过滤单元名称 -->
                    {{ $t("logs.Policy_unit4") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align: left; color: #0e2c5e">
                      {{ this.username }}
                    </p>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 域名或邮箱账号 -->
                    {{ $t("logs.notify7") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 4, maxRows: 8 }"
                      placeholder="一行一个地址"
                      v-model="users_ip"
                      style="margin: 8px 0"
                    >
                    </el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_ip">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_ip">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_ip"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label=""> </el-tab-pane>
      </el-tabs>
      <!-- regex -->
      <el-tabs v-show="tanchu_regex_all" v-loading="loading">
        <!-- regex -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.Policy_unit_regex1") }}</span>
          <div class="main">
            <el-button @click="save_regex_hide()">{{ $t("logs.Policy_back") }}</el-button>
            <el-button @click="save_regex_show()"  :disabled="$root.jurisdiction.only_query == 0">{{
              $t("logs.Policy_unit_regex2")
            }}</el-button>
            <el-alert
              :title="this.show_hint"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="switch1">
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList2"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="UNIT_NAME"
                  :label="$t('logs.Policy_unit4')"
                  width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="SHOW_TYPE"
                  :label="$t('logs.Policy_unit_regex3')"
                  width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="HEADER_KEY"
                  :label="$t('logs.Policy_unit_regex4')"
                  width="140"
                >
                </el-table-column>
                <el-table-column prop="UNIT_REGEX" :label="$t('logs.Policy_unit_regex5')">
                </el-table-column>
                <el-table-column
                  prop="SHOW_ISWORD"
                  :label="$t('logs.Policy_unit_regex6')"
                  width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('table1.operation')"
                  width="140"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                     :disabled="$root.jurisdiction.only_query == 0"
                      @click="handleClick_regex(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                    <!-- 编辑 -->

                    <el-button
                     :disabled="$root.jurisdiction.only_query == 0"
                      type="text"
                      size="small"
                      @click="unit_edit_regex(scope.$index, scope.row)"
                      >{{ $t("table1.ditt") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu_regex" v-drag>
              <div class="find">
                <div class="find1">
                  <!--过滤单元名称 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_unit4") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align: left; color: #0e2c5e">
                      {{ this.username }}
                    </p>
                  </div>
                </div>
                <div class="find1">
                  <!--类型 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("anti_gs1.User_type") }}:
                  </div>
                  <div class="block block1">
                    <el-select v-model="regex_type" @change="changyin01">
                      <el-option
                        v-for="item in regex_typee"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="find1" v-if="keyyin">
                  <!--信头key -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("anti_gs1.Headerkey") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="regex_header_key" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <!--过滤规则 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.group2") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="unit_regex" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <!--规则类型 -->

                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_unit_regex6") }}:
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="isword">
                      <el-radio :label="0"> {{ $t("logs.Regex_test2") }}</el-radio>
                      <el-radio :label="1">{{ $t("logs.Regex_test5") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_regex">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_regex">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_regex"></div>
            <div class="pop-up" v-show="tanchu_regex1" v-drag>
              <div class="find">
                <div class="find1">
                  <!--过滤单元名称 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_unit4") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align: left; color: #0e2c5e">
                      {{ this.username }}
                    </p>
                  </div>
                </div>
                <div class="find1">
                  <!--类型 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("anti_gs1.User_type") }}:
                  </div>
                  <div class="block block1">
                    <el-select v-model="regex_type" @change="changyin01">
                      <el-option
                        v-for="item in regex_typee"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="find1" v-if="keyyin">
                  <!--信头key -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("anti_gs1.Headerkey") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="regex_header_key" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <!--过滤规则 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.group2") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="unit_regex" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <!--规则类型 -->

                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_unit_regex6") }}:
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="isword">
                      <el-radio :label="0"> {{ $t("logs.Regex_test2") }}</el-radio>
                      <el-radio :label="1">{{ $t("logs.Regex_test5") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_regex_edit">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_regex1">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_regex1"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label=""> </el-tab-pane>
      </el-tabs>
      <!-- rule-->
      <el-tabs v-show="tanchu_rule_all" v-loading="loading">
        <!-- regex -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.Policy_unit_rule") }}</span>
          <div class="main">
            <el-button @click="save_rule_hide()">{{ $t("logs.Policy_back") }}</el-button>

            <el-alert
              :title="this.SHOW_RELATION1"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="main">
            <el-alert
              :title="this.SHOW_RELATION"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="table ruel_find">
            <div class="find">
              <!--邮件尺寸-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_msgsize") }}&lt;
                  </span>
                  <el-input
                    type="text"
                    v-model="maxmsgsize"
                    style="width: 15%; margin-right: 8px"
                  >
                  </el-input>
                  <el-select v-model="maxmsgsizeunit" style="width: 40%">
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_msgsize") }}&gt;=
                  </span>
                  <el-input
                    type="text"
                    v-model="minmsgsize"
                    style="width: 15%; margin-right: 8px"
                  >
                  </el-input>
                  <el-select v-model="minmsgsizeunit" style="width: 40%">
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!--正文尺寸-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_bodysize") }}&lt;
                  </span>
                  <el-input
                    type="text"
                    v-model="maxbodysize"
                    style="width: 15%; margin-right: 8px"
                  >
                  </el-input>
                  <el-select v-model="maxbodysizeunit" style="width: 40%">
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_bodysize") }}&gt;=
                  </span>
                  <el-input
                    type="text"
                    v-model="minbodysize"
                    style="width: 15%; margin-right: 8px"
                  >
                  </el-input>
                  <el-select v-model="minbodysizeunit" style="width: 40%">
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!--附件尺寸-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_attsize") }}&lt;
                  </span>
                  <el-input
                    type="text"
                    v-model="maxattsize"
                    style="width: 15%; margin-right: 8px"
                  >
                  </el-input>
                  <el-select v-model="maxattsizeunit" style="width: 40%">
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_attsize") }}&gt;=
                  </span>
                  <el-input
                    type="text"
                    v-model="minattsize"
                    style="width: 15%; margin-right: 8px"
                  >
                  </el-input>
                  <el-select v-model="minattsizeunit" style="width: 40%">
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!--附件数量-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_attnum") }}&lt;
                  </span>
                  <el-input
                    type="text"
                    v-model="maxattnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_attnum") }}&gt;=
                  </span>
                  <el-input
                    type="text"
                    v-model="minattnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
              </div>
              <!--收件人数量-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_rcptnum") }}&lt;
                  </span>
                  <el-input
                    type="text"
                    v-model="maxrcptnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_rcptnum") }}&gt;=
                  </span>
                  <el-input
                    type="text"
                    v-model="minrcptnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
              </div>
              <!--外部收件人数-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_bsrcptnum") }}&lt;
                  </span>
                  <el-input
                    type="text"
                    v-model="maxoutrcptnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_bsrcptnum") }}&gt;=
                  </span>
                  <el-input
                    type="text"
                    v-model="minoutrcptnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
              </div>
              <!--大站点收件人数-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_outrcptnum") }}&lt;
                  </span>
                  <el-input
                    type="text"
                    v-model="maxbsrcptnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_outrcptnum") }}&gt;=
                  </span>
                  <el-input
                    type="text"
                    v-model="minbsrcptnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
              </div>
              <!--暗送收件人数-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_bccnum") }}&lt;
                  </span>
                  <el-input
                    type="text"
                    v-model="maxbccnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_bccnum") }}&gt;=
                  </span>
                  <el-input
                    type="text"
                    v-model="minbccnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
              </div>
              <!--白名单检查-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_Checkwhite") }}:
                  </span>
                  <el-select v-model="checkwl" style="width: 57%">
                    <el-option
                      v-for="item in checkwll"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_Checknettype") }}:
                  </span>
                  <el-select v-model="nettype" style="width: 57%">
                    <el-option
                      v-for="item in nettypee"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!--时间范围-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_Timerange") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="starttime"
                    style="width: 28%; margin-right: 1%"
                    class="ruel_find_input"
                    placeholder="0-23"
                  >
                  </el-input>
                  <el-input
                    type="text"
                    v-model="endtime"
                    style="width: 28%"
                    class="ruel_find_input"
                    placeholder="1-24"
                  >
                  </el-input>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_Checkfrom") }}:
                  </span>
                  <el-select v-model="chknullfrom" style="width: 57%">
                    <el-option
                      v-for="item in chknullfromm"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <el-row>
              <!-- 保存 -->

              <el-button type="primary" @click="save_rule"  :disabled="$root.jurisdiction.only_query == 0">{{
                $t("tab.save")
              }}</el-button>
              <!-- 取消 -->

              <!-- <el-button type="danger" @click="save11">{{ $t("tab.cancel") }}</el-button>-->
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label=""> </el-tab-pane>
      </el-tabs>
      <!-- url -->
      <el-tabs v-show="tanchu_url_all" v-loading="loading">
        <!-- url -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.Policy_unit_url1") }}</span>
          <div class="main">
            <el-button @click="save_url1_hide()">{{ $t("logs.Policy_back") }}</el-button>
            <el-button @click="save_url1_show()"  :disabled="$root.jurisdiction.only_query == 0">{{
              $t("logs.Policy_unit_url2")
            }}</el-button>
          </div>
          <div class="switch1">
            <div class="table tableurl">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList6"
                :row-class-name="tableRowClassName"
              >
                <el-table-column prop="RECSEQ" :label="$t('table1.order')" width="100">
                </el-table-column>
                <el-table-column prop="UNIT_NAME" :label="$t('logs.Policy_unit4')">
                </el-table-column>

                <el-table-column prop="URLDN" :label="$t('logs.Policy_unit_url1')">
                </el-table-column>

                <el-table-column
                  prop="address"
                  :label="$t('table1.operation')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                     :disabled="$root.jurisdiction.only_query == 0"
                      @click="handleClick_url1(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu_url1">
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 过滤单元名称 -->
                    {{ $t("logs.Policy_unit4") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align: left; color: #0e2c5e">
                      {{ this.username }}
                    </p>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!--url 地址 -->
                    {{ $t("logs.Policy_unit_url1") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 4, maxRows: 8 }"
                      placeholder="一行一个地址"
                      v-model="urls_ip"
                      style="margin: 8px 0"
                    >
                    </el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_url1">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_url1">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_url1"></div>
          </div>
        </el-tab-pane>
        <!-- url解析 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.Policy_unit_url3") }}</span>
          <div class="main">
            <el-button @click="save_url1_hide()">{{ $t("logs.Policy_back") }}</el-button>
            <el-button @click="save_url1_show()"  :disabled="$root.jurisdiction.only_query == 0">{{
              $t("logs.Policy_unit_url4")
            }}</el-button>
            <el-alert
              :title="$t('logs.Policy_unit2')"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="switch1">
            <div class="table tableurl">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList7"
                :row-class-name="tableRowClassName"
              >
                <el-table-column prop="RECSEQ" :label="$t('table1.order')">
                </el-table-column>
                <el-table-column prop="UNIT_NAME" :label="$t('logs.Policy_unit4')">
                </el-table-column>

                <el-table-column prop="URLIP" :label="$t('logs.Policy_unit_url3')">
                </el-table-column>

                <el-table-column prop="address" :label="$t('table1.operation')">
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                     :disabled="$root.jurisdiction.only_query == 0"
                      @click="handleClick_url2(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu_url1">
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 过滤单元名称 -->
                    {{ $t("logs.Policy_unit4") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align: left; color: #0e2c5e">
                      {{ this.username }}
                    </p>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- url 解析 -->
                    {{ $t("logs.Policy_unit_url3") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 4, maxRows: 8 }"
                      placeholder="一行一个地址"
                      v-model="urls_ip1"
                      style="margin: 8px 0"
                    >
                    </el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_url2">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_url1">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_url1"></div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mixinsTest } from "../../tool/mixins.js";

export default {
  mixins: [mixinsTest],
  data() {
    return {
      policy_priv_add_edit: [],
      save_day_radio_saveday: "",
      radio_saveday: "",
      save_day: "",
      timedefer_hint_show:"",
      routing_setup_instructions:
        '#每一条路由设置，均为一条json格式，一行一条json。bcc设置抄送到某一个地址，并route到指定地址。其他为针对命中条件路由。unpoll，默认为0，轮询，设置1，表示不轮询，优先级按次序排序，可不设置。<br>//只route指定域名，并且主备方式{"act":"alt-mailhost","rcpt":"example.com","route":"10.88.2.82,10.88.2.22.2","unpoll":1}<br>//命中策略，所有收件人都更改到route{"act":"alt-mailhost","rcpt":"*","route":"10.88.2.82,10.88.2.22.2"}<br>//命中策略，只对指定收件人地址更改route{"act":"alt-mailhost","rcpt":"test@xx.com","route":"10.88.2.82,10.88.2.22.2"}<br>//设置bcc以及路由{"act":"bcc","rcpt":"bcc@example.com","route":"10.88.2.82,10.88.2.22.2"',
      policy_priv_show: 0,
      table_role_show: 1,
      table_role_add: 0,
      table_role_edit: 0,

      drawer: false,
      show_macro_list: "",
      ip_domain_text: "",
      policy_route_json_str: "",
      edit_show: 0,
      options1: [
        {
          label: "KB",
          value: "KB",
        },
        {
          label: "MB",
          value: "MB",
        },
        {
          label: "B",
          value: "B",
        },
      ],
      fileList2: [],
      fileList_2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      fileList6: [],
      fileList7: [],
      // 是否检查判断

      cfgcheck_check: "",
      // 中心节点判断
      runoncenter_center: "",
      urls_ip: "",
      urls_ip1: "",
      SHOW_RELATION: "",
      SHOW_RELATION1: "",
      unit_regex1: "",
      isword: "",
      users_ip: "",
      users: "",
      users_reciplent: "",
      users_sender: "",
      regex_header_key: "",
      unit_regex: "",
      regex_type: "SUBJECT",
      regex_typee: [],

      filter_unit_name: "",
      keyyin: false,
      loading: false,
      show_hint: "",
      newadd_fiter: 1,
      // username
      username: "",
      // 单元条件规则设置
      maxmsgsize: "",
      maxmsgsizeunit: "KB",
      minmsgsize: "",
      minmsgsizeunit: "KB",
      maxbodysize: "",
      maxbodysizeunit: "KB",
      minbodysize: "",
      minbodysizeunit: "KB",
      maxattsize: "",
      maxattsizeunit: "KB",
      minattsize: "",
      minattsizeunit: "KB",
      maxattnum: "",
      minattnum: "",
      maxrcptnum: "",
      minrcptnum: "",
      maxoutrcptnum: "",
      minoutrcptnum: "",
      maxbsrcptnum: "",
      minbsrcptnum: "",
      maxbccnum: "",
      minbccnum: "",
      checkwl: "",
      checkwll: [],
      nettype: "",
      nettypee: [],
      chknullfrom: "",
      chknullfromm: [],
      starttime: "",
      endtime: "",

      serder_name: "",
      reciplent_name: "",
      ip_name: "",
      regex_name: "",
      url1_name: "",
      url2_name: "",
      dnoremail: "",
      other_is_and: "",
      regex_is_and: "",
      unit_name_edit: "",
      // 组合策略
      tanchu_sender: false,
      tanchu_sender_all: false,
      tanchu_reciplent: false,
      tanchu_reciplent_all: false,
      tanchu_ip: false,
      tanchu_ip_all: false,
      tanchu_regex: false,
      tanchu_regex1: false,
      tanchu_regex_all: false,
      tanchu_rule_all: false,
      // tanchu_rul_all: true,
      tanchu_url1: false,
      tanchu_url_all: false,

      // 组合策略 结束
      options: [
        {
          value: "KB",
          label: "KB",
        },
        {
          value: "MB",
          label: "MB",
        },
        {
          value: "B",
          label: "B",
        },
      ],

      radio_poll: 1,

      pickerOptions: {
        disabledDate(time) {
          // return time.getTime() > Date.now();
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      manself_show: 0,
      manself: 0,
      manself_text: "",
      new_policy_name_hind: "",
      notify_subject1: "",
      notify_inc_eml1: "",
      has_notice_tem: "",
      has_timer_rdefer:false,
      notify_body1: "",
      envfrom1: "",
      new_policy_name1: "",
      notify_inc_eml: "",
      notify_body_template: "",
      notify_subject: "",
      notify_envfrom: "",
      // notify_inc_eml: '',
      // notify_body_template: '',
      tanchu_setting: false,
      add_new_policy_name: "",
      tanchu_edit: false,
      // 通知设置
      notify_mode: "",
      CFGCHECK: "",
      OFFLINE: "",
      RUN_ON_CENTER: "",
      subflag: "",
      ip_domain_show: "",
      ip_domain: "",
      ip_domain_test: "",
      policy_addsub: "",
      addsub_hint: "",
      policy_nto: "",
      notify_email: "",
      defer_time: "",
      defer_time1: "",
      alert_rate_minute: "",
      cc_email: "",
      policy_cc: "",
      fwd_email: "",
      policy_fwd: "",
      multi_address_hint: "",
      policy_comb_name_hint: "",
      policy_comb_explam: "",
      policy_type_arr: [],
      policy_action_arr: [],
      new_policy_name: "",
      new_policy_rule: "",
      new_comb_rule: "",
      new_comb_rule_show: 0,
      // disableatoffline: '',
      priority1: 0,
      // new_policy_rule: '',
      // new_policy_name:'',
      // 添加策略
      comb_name: "",
      comb_rule: "",
      priority: "",
      disableatoffline: "",
      disableatoffline1: "",
      policy_action: "REJECT",
      description: "",
      policy_name: "",
      policy_rule: "",
      remark: "",
      direct: "",
      active: "",
      runoncenter: "",
      cfgcheck: "",
      policy_type: 0,
      chkexpire: "",
      expire: "",
      comb_action: [],
      textarea: "",
      input: "",
      time: new Date(2020, 9, 10, 18, 40),
      value1: "",

      tableData: [
        {
          address: "44",
        },
      ],
      emali: "",
      value: "",
      checkList: [],
      tanchu: false,
      option1: [
        {
          value: "选项1",
        },
        {
          value: "%",
        },
        {
          value: "选项2",
        },
        {
          value: "选项3",
        },
      ],
      timer_hour:'',
      timer_hour_show:'',
      timer_min:'',
      timer_min_show:'',
      checked: "",
      fileList: [],
      radio: [],
      has_fwd: false,
      has_cc: false,
      has_defer: false,
      has_notify: false,
      has_addsub: false,
      has_policy_route: false,
      change_show: "",
      noty_ok: "",
      showmacro_list: false,
      showmacro_list1: true,
      showmacro: [],
      policy_rule_select: "",
      policy_rule_select_arr: [],
      select_combrule: "",
      select_combrule_arr: [],
      checkedCities_dafa:[],
      is_white_rule:'',
      option_action:'',
    option_select:false,
option_action_arr:[],

    has_cc_option: false,
      option_policy_cc:'',
    };
  },

  mounted() {
    this.getFileList1();
    this.tan_showmacro2();
  },
  methods: {
     // 可选动作
    change_action_option(val){
      console.log(val)
      if(val=='CC'){
        this.has_cc_option=true
      }else{
        this.has_cc_option=false

      }
    },
     dianji(a) {
       this.table_role_show=1;
        this.table_role_add=0;
            // console.log(a.index)
            this.is_white_rule = a.index
            this.getFileList1();

        },
    add_policy_rule(value) {
      console.log(value);
      this.policy_rule += value;
      console.log(this.policy_rule, "策略规则的值");
    },
    add_comb_rule(value) {
      console.log(value);
      this.comb_rule += value;
      console.log(this.comb_rule, "组合策略的值");
    },
    handleCheckAllChange(val) {
      console.log(val);
      this.checkedCities = val ? this.policy_priv_add_edit.map((ele) => ele.key) : [];
       this.isIndeterminate = false;
      // this.isArr_priv();
    },
handleCheckedCitiesChange_role(val,index_val){
   console.log(val,index_val);
   if(index_val.check_show){


        console.log('到这来')
        this.$forceUpdate()

      }
},
    handleCheckedCitiesChange(value) {
      console.log(value);
      
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.policy_priv_add_edit.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.policy_priv_add_edit.length;
      // console.log( this.checkAll,this.isIndeterminate ,checkedCount)
      // this.isArr_priv();
    },
    isArr_priv() {
      this.policy_priv.forEach((value) => {
        if (this.checkedCities.includes(value.key)) {
          value.value = 1;
        } else {
          value.value = 0;
        }
      });
      console.log(this.checkedCities, this.policy_priv_add_edit);
    },
    off_policy() {
      this.table_role_add = 0;
      this.table_role_show = 1;
    },

    // 判断状态变色
    // tableCellClassName({
    //     row,

    // }) {
    //     // console.log(row);

    //     if (row.ACTIVE == 1) {
    //         return "sent1";
    //     } else if (row.ACTIVE == 0) {
    //         return "sent2";
    //     }
    //     return "";
    // },
    // 策略名称操作

    handleEdit1(index, row) {
      // console.log(row);
      this.fileList[index].SHOW_EDIT = row.SHOW_EDIT == 0 ? 1 : 0;
    },
    handleEdit2(index, row) {
      // console.log(row);
      this.fileList[index].SHOW_EDIT = row.SHOW_EDIT == 0 ? 1 : 0;
    },
    tan_showmacro1() {
      this.showmacro_list = false;
      this.showmacro_list1 = true;
    },
    tan_showmacro() {
      this.showmacro_list = true;
      this.showmacro_list1 = false;
    },
    tan_showmacro2() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/aspam.cgi", {
          params: {
            __mode: "showmacro",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            // this.getFileList();
          } else if (res.data.fmstatus.code == "2") {
            // alert(res.data.fmstatus.errmsg);
            // this.getFileList();
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.showmacro = res.data.ret.datalist;
          }
        });
    },
    changyin01(a) {
      // console.log(a);

      if (a == "HEADERS") {
        this.keyyin = true;
      } else {
        this.keyyin = false;
      }
    },
    // 过滤单元编辑
    unit_edit_regex(index, scope) {
      this.tanchu_regex1 = true;
      this.username = scope.UNIT_NAME;
      this.regex_type = scope.TYPE;
      this.unit_regex = scope.UNIT_REGEX;
      this.unit_regex1 = scope.UNIT_REGEX;
      this.isword = scope.ISWORD;
      this.regex_header_key = scope.HEADER_KEY;

      console.log(scope);
    },
    // 过滤组合保存
    save_comb() {
      // this.loading = true;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_unit_email",
        sid: sid,
        unit_name: this.username,
        users: this.users_sender,
        type: 1,
        bulkadd: 1,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        console.log(res);

        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.tanchu_sender = false;
          this.loading = false;
          this.getFileList2();
        }
      });

      this.real_code = "";
      this.real_addr = "";
    },
    //正则表达式测试保存
    pcre_test() {
      // this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let str = this.$qs.stringify({
        __mode: "pcre_test",
        sid: sid,
        test_value: this.test_value,
        regular: this.regular,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        console.log(res);

        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.readonly = res.data.ret.RESULT;
          this.loading = false;
          // this.getFileList3()
        }
      });
    },
    // 过滤组合加载
    getFileList2_comb() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_policy_comb",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList_2 = res.data.ret.datalist;
            this.runoncenter_center = res.data.ret.RUN_ON_CENTER;
            this.cfgcheck_check = res.data.ret.CFGCHECK;
          }
        });
    },
    //  url编辑
    // 过滤单元删除
    handleClick_url2(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let unit_name = scope.UNIT_NAME;
          let str = this.$qs.stringify({
            __mode: "del_unit_urlip",
            sid: sid,
            unit_name: unit_name,
            urlip: scope.URLIP,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList7();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // url解析加载
    getFileList7() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_unit_urlip",
            sid: sid,
            unit_name: this.username,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList7 = res.data.ret.datalist;

            // this.regex_typee = res.data.ret.q_regex_type
            this.loading = false;
          }
        });
    },
    //  url编辑
    // 过滤单元删除
    handleClick_url1(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let unit_name = scope.UNIT_NAME;
          let str = this.$qs.stringify({
            __mode: "del_unit_urldn",
            sid: sid,
            unit_name: unit_name,
            urldn: scope.URLDN,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList6();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // url加载
    getFileList6() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_unit_urldn",
            sid: sid,
            unit_name: this.username,
          },
        })
        .then((res) => {
          // console.log(res);

          // this.loading = true;
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList6 = res.data.ret.datalist;
            this.show_hint = res.data.ret.SHOW_HINT;
            // this.regex_typee = res.data.ret.q_regex_type
            this.loading = false;
          }
        });
    },
    // 条件规则保存
    save_rule() {
      this.$save_hint_test();
      // this.loading = true;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_unit_other",
        sid: sid,
        unit_name: this.username,
        maxmsgsize: this.maxmsgsize,
        minmsgsize: this.minmsgsize,
        maxbodysize: this.maxbodysize,
        minbodysize: this.minbodysize,
        maxattsize: this.maxattsize,
        minattsize: this.minattsize,
        maxattnum: this.maxattnum,
        minattnum: this.minattnum,
        maxrcptnum: this.maxrcptnum,
        minrcptnum: this.minrcptnum,
        maxoutrcptnum: this.maxoutrcptnum,
        minoutrcptnum: this.minoutrcptnum,
        maxbsrcptnum: this.maxbsrcptnum,
        minbsrcptnum: this.minbsrcptnum,
        maxbccnum: this.maxbccnum,
        minbccnum: this.minbccnum,
        starttime: this.starttime,
        endtime: this.endtime,

        checkwl: this.checkwl,
        chknullfrom: this.chknullfrom,
        nettype: this.nettype,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.loading = false;
          this.getFileList4();
        }
      });
    },
    // 条件规则加载
    getFileList4() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "edit_unit_other",
            sid: sid,
            unit_name: this.username,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.show_hint = res.data.ret.SHOW_HINT;
            this.maxmsgsize = res.data.ret.MAXMSGSIZE;
            this.minmsgsize = res.data.ret.MINMSGSIZE;
            this.maxbodysize = res.data.ret.MAXBODYSIZE;
            this.minbodysize = res.data.ret.MINBODYSIZE;
            this.maxattsize = res.data.ret.MAXATTSIZE;
            this.minattsize = res.data.ret.MINATTSIZE;
            this.maxattnum = res.data.ret.MAXATTNUM;
            this.minattnum = res.data.ret.MINATTNUM;
            this.maxrcptnum = res.data.ret.MAXRCPTNUM;
            this.minrcptnum = res.data.ret.MINRCPTNUM;
            this.maxoutrcptnum = res.data.ret.MAXOUTRCPTNUM;
            this.minoutrcptnum = res.data.ret.MINOUTRCPTNUM;
            this.maxbsrcptnum = res.data.ret.MAXBSRCPTNUM;
            this.minbsrcptnum = res.data.ret.MINBSRCPTNUM;
            this.maxbccnum = res.data.ret.MAXBCCNUM;
            this.minbccnum = res.data.ret.MINBCCNUM;
            this.starttime = res.data.ret.STARTTIME;
            this.endtime = res.data.ret.ENDTIME;
            this.SHOW_RELATION1 = res.data.ret.SHOW_HINT;
            this.SHOW_RELATION = res.data.ret.SHOW_RELATION;
            this.checkwl = res.data.ret.CHECKWL;
            this.chknullfrom = res.data.ret.CHKNULLFROM;
            this.nettype = res.data.ret.NETTYPE;
            this.checkwll = res.data.ret.q_checkwl;
            this.nettypee = res.data.ret.q_nettype;
            this.chknullfromm = res.data.ret.q_chknullfrom;
            this.loading = false;
          }
        });
    },
    // 内容过滤加载
    getFileList3() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_unit_regex",
            sid: sid,
            unit_name: this.username,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList2 = res.data.ret.datalist;
            this.show_hint = res.data.ret.SHOW_HINT;
            this.regex_typee = res.data.ret.q_regex_type;
            this.loading = false;
          }
        });
    },
    // regex 删除保存
    handleClick_regex(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let rule_id = scope.RULE_ID;

          let str = this.$qs.stringify({
            __mode: "del_unit_regex",
            sid: sid,
            rule_id: rule_id,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList3();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },

    // regex 添加保存
    save_regex() {
      // this.loading = true;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
this.$save_hint_test();
      let str = this.$qs.stringify({
        __mode: "save_unit_regex",
        sid: sid,
        unit_name: this.username,
        users: this.users_sender,
        type: this.regex_type,
        unit_regex: this.unit_regex,
        isword: this.isword,
        newadd: 1,
        header_key: this.regex_header_key,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.tanchu_regex = false;
          this.loading = false;
          this.getFileList3();
        }
      });
    },
    // 发件人加载
    getFileList2() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_unit_email",
            sid: sid,
            unit_name: this.username,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList2 = res.data.ret.datalist;
            this.show_hint = res.data.ret.SHOW_HINT;
            this.loading = false;
          }
        });
    },
    // 发件人保存
    save_sender() {
      this.$save_hint_test();
      // this.loading = true;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_unit_email",
        sid: sid,
        unit_name: this.username,
        users: this.users_sender,
        type: 1,
        bulkadd: 1,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        console.log(res);
this.$close_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.tanchu_sender = false;
          this.loading = false;
          this.getFileList2();
        }
      });

      this.real_code = "";
      this.real_addr = "";
    },
    // 收件人保存
    save_reciplent() {
      // this.loading = true;
      this.$save_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_unit_email",
        sid: sid,
        unit_name: this.username,
        users: this.users_reciplent,
        type: 2,
        bulkadd: 1,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.tanchu_reciplent = false;
          this.loading = false;
          this.getFileList2();
        }
      });

      this.real_code = "";
      this.real_addr = "";
    },
    // ip保存
    save_ip() {
      // this.loading = true;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
this.$save_hint_test();
      let str = this.$qs.stringify({
        __mode: "save_unit_ip",
        sid: sid,
        unit_name: this.username,
        addrs: this.users_ip,

        bulkadd: 1,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.tanchu_ip = false;
          this.loading = false;
          this.getFileList2();
        }
      });

      this.real_code = "";
      this.real_addr = "";
    },
    // 发件人删除
    handleClick_sender(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let unit_name = scope.UNIT_NAME;
          let dnoremail = scope.DNOREMAIL;
          let type = scope.TYPE;
          let str = this.$qs.stringify({
            __mode: "del_unit_email",
            sid: sid,
            unit_name: unit_name,
            dnoremail: dnoremail,
            type: type,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList2();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },

    // regex编辑保存
    save_regex_edit() {
      // this.bxian1 = false
      // this.bxian = true
      // this.loading = true;
      this.tanchu_edit = false;
      this.$save_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // let unit_name = scope.UNIT_NAME
      // let unit_type = scope.UNIT_TYPE
      // let regex_is_and = scope.IS_AND
      let oldregex = this.unit_regex1;
      let str = this.$qs.stringify({
        __mode: "save_unit_regex",
        sid: sid,
        unit_name: this.username,
        users: this.users_sender,
        type: this.regex_type,
        oldregex: oldregex,
        unit_regex: this.unit_regex,
        isword: this.isword,
        newadd: 0,
        header_key: this.regex_header_key,
      });
      console.log(str, "555555555");
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu_regex1 = false;
          this.loading = false;
          this.getFileList3();
        }
      });
    },
    // 过滤单元编辑
    unit_edit(index, scope) {
      this.tanchu_edit = true;
      this.unit_name_edit = scope.UNIT_NAME;
      this.unit_type = scope.UNIT_TYPE;
      this.remark = scope.REMARK;
      this.other_is_and = scope.IS_AND;
      this.regex_is_and = scope.IS_AND;

      if (scope.UNIT_TYPE == 4) {
        (this.regex_is_and_hidden = true),
          (this.other_is_and_hidden = false),
          (this.urlcondition_hidden = false),
          (this.urlcondition_yes_hidden = false);
      } else if (scope.UNIT_TYPE == 5) {
        (this.other_is_and_hidden = true),
          (this.regex_is_and_hidden = false),
          (this.urlcondition_hidden = false),
          (this.urlcondition_yes_hidden = false);
      } else if (scope.UNIT_TYPE == "6") {
        this.urlcondition = 0;
        (this.urlcondition_hidden = true),
          (this.regex_is_and_hidden = false),
          (this.other_is_and_hidden = false);
      } else
        (this.regex_is_and_hidden = false),
          (this.urlcondition_hidden = false),
          (this.other_is_and_hidden = false),
          (this.urlcondition_yes_hidden = false);
      // console.log(scope)
    },
    // 过滤单元删除
    handleClick1(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let unit_name = scope.UNIT_NAME;
          let str = this.$qs.stringify({
            __mode: "del_policy_unit",
            sid: sid,
            unit_name: unit_name,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList1();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },

    // url1 解析编辑保存
    save_url2() {
      // this.loading = true;
      this.$save_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_unit_urlip",
        sid: sid,
        unit_name: this.username,
        urlips: this.urls_ip1,

        bulkadd: 1,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        console.log(res);
this.$close_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.tanchu_url1 = false;
          this.loading = false;
          this.getFileList7();
        }
      });
    },
    // url1编辑保存
    save_url1() {
      // this.loading = true;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
this.$save_hint_test();
      let str = this.$qs.stringify({
        __mode: "save_unit_urldn",
        sid: sid,
        unit_name: this.username,
        urls: this.urls_ip,

        bulkadd: 1,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        console.log(res);
this.$close_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.tanchu_url1 = false;
          this.loading = false;
          this.getFileList6();
        }
      });
    },
    // url1编辑
    off_url1() {
      this.tanchu_url1 = false;
    },

    // regex编辑
    off_regex() {
      this.tanchu_regex = false;
    },
    // regex编辑
    off_regex1() {
      this.tanchu_regex1 = false;
    },

    // ip编辑
    off_ip() {
      this.tanchu_ip = false;
    },

    // 发件人编辑
    off_reciplent() {
      this.tanchu_reciplent = false;
    },
    off_sender() {
      this.tanchu_sender = false;
    },
    // 打开关闭
    tanSend: function () {
      this.tanchu = false;
    },

    unit_off: function () {
      this.tanchu_edit = false;
    },

    save_sender_show() {
      this.tanchu_sender = true;
      this.users_sender = "";
    },
    save_reciplent_show() {
      this.tanchu_reciplent = true;
      this.users_reciplent = "";
    },
    save_ip_show() {
      this.tanchu_ip = true;
      this.users_ip = "";
    },
    save_regex_show() {
      this.tanchu_regex = true;
      this.regex_type = "SUBJECT";
      this.unit_regex = "";
      this.isword = "1";
      this.regex_header_key = "";
    },
    save_url1_show() {
      this.tanchu_url1 = true;
    },
    save_url2_show() {
      this.tanchu_url2 = true;
    },
    // 保存
    save11() {
      this.tanchu = false;
    },
    // 取消
    save12() {
      this.tanchu = false;
    },
    // 返回
    save_url1_hide() {
      this.tanchu_url_all = false;
      this.xian1 = true;
    },
    // 返回
    save_sender_hide() {
      this.tanchu_sender_all = false;
      this.xian1 = true;
    },
    // 返回tanchu_reciplent_all
    save_reciplent_hide() {
      this.tanchu_reciplent_all = false;
      this.xian1 = true;
    },
    // 返回
    save_ip_hide() {
      this.tanchu_ip_all = false;
      this.xian1 = true;
    },
    // 返回
    save_regex_hide() {
      this.tanchu_regex_all = false;
      this.xian1 = true;
    },
    // 返回
    save_rule_hide() {
      this.tanchu_rule_all = false;
      this.xian1 = true;
    },
    // 组合策略 判断
    rule_combine(val, val1, val2) {
if (this.$root.jurisdiction.only_query != 0) {
      let polity = val1;
      let combine = val2.COMB_HASH[polity];
      this.username = val1;
      // console.log(this.username)
      // console.log(val2)
      // console.log(val2.COMB_HASH[polity], '第几个')
      if (combine == 1) {
        this.tanchu_sender_all = true;
        this.xian1 = false;

        this.getFileList2();
      } else if (combine == 2) {
        this.tanchu_reciplent_all = true;
        this.xian1 = false;
        this.getFileList2();
      } else if (combine == 3) {
        this.tanchu_ip_all = true;
        this.xian1 = false;
        this.getFileList2();
      } else if (combine == 4) {
        this.tanchu_regex_all = true;
        this.xian1 = false;
        this.getFileList3();
      } else if (combine == 5) {
        this.tanchu_rule_all = true;
        this.xian1 = false;
        this.getFileList4();
      } else if (combine == 6) {
        this.tanchu_url_all = true;
        this.xian1 = false;
        this.getFileList6();
        this.getFileList7();
      }
    }
    },
    rule_a() {
      console.log(111);
    },

    // 规则判断

    isClick(str) {
      if (!str) {
        return [];
      }
      let arr = [];
      let str1 = "";
      let bol = false;
      for (let i = 0; i < str.length; ++i) {
        if (/^[a-zA-Z0-9]$/.test(str[i])) {
          if (bol) {
            str1 += str[i];
          } else {
            bol = true;
            if (str1) {
              arr.push({
                bol: false,
                val: str1,
              });
              str1 = "";
              str1 += str[i];
            } else {
              str1 += str[i];
            }
          }
        } else {
          if (!bol) {
            str1 += str[i];
          } else {
            bol = false;
            if (str1) {
              arr.push({
                bol: true,
                val: str1,
              });
              str1 = "";
              str1 += str[i];
            } else {
              str1 += str[i];
            }
          }
        }
        if (i == str.length - 1) {
          if (bol) {
            arr.push({
              bol: true,
              val: str1,
            });
          } else {
            arr.push({
              bol: false,
              val: str1,
            });
          }
        }
      }
      return arr;
    },
    rule_policy(val, val1) {
    if (this.$root.jurisdiction.only_query != 0) {
      console.log(val, val1);
      if (val == true) {
        this.xian1 = false;
        this.xian2 = true;
        this.xian3 = 1;
        let filter_name = val1;
        let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
        // console.log(sid);
        this.loading = true;
        this.$axios
          .get("/api/adm/cgi/aspam.cgi", {
            params: {
              __mode: "edit_filter",
              sid: sid,
              filter_name: filter_name,
            },
          })
          .then((res) => {
            console.log(res);

            if (!res) {
              this.loading = false;
            } else if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
              this.loading = false;
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              this.loading = false;
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
               this.q_spf_result = res.data.ret.q_spf_result;
              this.show_macro_list = res.data.ret.SYS_CAN_SEE_MACRO_LIST;
 this.q_dft_keyword = res.data.ret.q_dft_keyword;
              console.log(  this.q_dft_keyword)
              this.alink_out_relation = res.data.ret.alinkrelation;
              this.filter_name = res.data.ret.filter_name;
              this.filter_describe = res.data.ret.filter_describe;
              this.rootcondrelation = res.data.ret.rootcondrelation;
              this.rootcontrelation = res.data.ret.rootcontrelation;
              this.content_name_default = res.data.ret.q_content_name[0].value;
              // let a = res.data.ret.condition
              this.chkcontent =
                res.data.ret.chkcontent == 1
                  ? (this.chkcontent = true)
                  : (this.chkcontent = false);
              this.chkcondition =
                res.data.ret.chkcondition == 1
                  ? (res.data.ret.chkcondition = true)
                  : false;
              this.chkalink =
                res.data.ret.chkalink == 1 ? (res.data.ret.chkalink = true) : false;
              if (res.data.ret.condition) {
                this.tiaoa = res.data.ret.condition;
              }
              if (res.data.ret.content) {
                console.log(res.data.ret.content);
                this.contentList = res.data.ret.content;
                for (let i = 0; i < this.contentList.length; i++) {
                  for (let v = 0; v < this.contentList[i].contentList1.length; v++) {
                    //   let condition_select_first = a[i].tiaob[v].condition_name;
                    console.log(this.contentList[i].contentList1[v]);
                    if (this.contentList[i].contentList1[v].checkedCities) {
                      this.contentList[i].contentList1[v].checkedCities = JSON.parse(
                        this.contentList[i].contentList1[v].checkedCities
                      );
                    } else {
                      this.contentList[i].contentList1[v].policy_priv = this.policy_priv;
                       this.contentList[i].contentList1[v].check_show = 1
                      this.contentList[i].contentList1[v]. checkedCities= this.q_dft_keyword;
                      console.log(this.contentList[i].contentList1[v], "这是什么");
                    }
                  }
                }
              } else {
                                this.contentList = [{
                                    id: 1,
                                    content_out_relation: 1,

                                    contentList1: [{
                                        id: 1,
                                        score: "",
                                        content_name: this.content_name_default,
                                        content_namee0: [],
                                        content_relation: 1,
                                        content_relation2: 1,
                                        content_relationn0: [],
                                        content_relationn2: [],
                                        content_type: 0,
                                        content_typee0: "",
                                        content_type2: 0,
                                        content_typee2: "",
                                        content_exist: 1,
                                        content_existt: [],
                                        content_matchcn: "",
                                        content_match: 0,
                                        content_matchh: [],
                                        header_key: "",
                                        policy_priv: [],
                                        checkedCities: this.q_dft_keyword,

                                    }, ],
                                }, ];
                            }
              if (res.data.ret.alink) {
                this.alinkList = res.data.ret.alink;
              }

              this.policy_priv = res.data.ret.q_keyword_type;
              this.contentList[0].contentList1[0].policy_priv =
                res.data.ret.q_keyword_type;
              this.contentList[0].contentList1[0].content_typee2 =
                res.data.ret.q_content_type2;
              this.contentList[0].contentList1[0].content_relationn2 =
                res.data.ret.q_content_relation2;

              this.white_typee = res.data.ret.q_condition_white;

              this.network_type00 = res.data.ret.q_condition_network;
              this.condition_namee0 = res.data.ret.q_condition_name;
              this.msgsize_typee0 = res.data.ret.q_condition_equal;
              this.sublen_typee = res.data.ret.q_condition_equal2;
              this.content_namee0 = res.data.ret.q_content_name;
              this.content_relationn0 = res.data.ret.q_content_relation;
              this.content_relationn2 = res.data.ret.q_content_relation2;
              this.content_typee0 = res.data.ret.q_content_type;
              this.content_typee2 = res.data.ret.q_content_type2;
              this.content_existt = res.data.ret.q_content_exist;
              this.content_matchh = res.data.ret.q_content_match;
              this.alink_namee0 = res.data.ret.q_alink_name;
              this.alink_relationn0 = res.data.ret.q_content_relation;
              this.alink_typee0 = res.data.ret.q_content_type;
            }
          });
      }
    }
    },
    change_action(a) {
      console.log(a);
      if (a == "FWD") {
        this.has_notice_tem = false;
        this.has_fwd = true;
        this.has_cc = false;
        this.has_defer = false;
        this.has_notify = false;
        this.has_addsub = false;
        this.has_policy_route = false;
         this.has_timer_rdefer = false;
      } else if (a == "CC") {
        this.has_cc = true;
        this.has_fwd = false;
        this.has_notice_tem = false;
        this.has_defer = false;
        this.has_notify = false;
        this.has_addsub = false;
        this.has_policy_route = false;
         this.has_timer_rdefer = false;
      } else if (a == "DEFER") {
        this.has_defer = true;
        this.has_fwd = false;
        this.has_cc = false;
        this.has_policy_route = false;
        this.has_notice_tem = false;
        this.has_notify = false;
        this.has_addsub = false;
         this.has_timer_rdefer = false;
      } else if (a == "NOTIFYOTHER" ||a=="BYPASSANDTOOTHER") {
        this.has_notify = true;
        this.has_fwd = false;
        this.has_cc = false;
        this.has_policy_route = false;
        this.has_defer = false;
        this.has_notice_tem = true;
        this.has_addsub = false;
         this.has_timer_rdefer = false;
      } else if (a == "ADDSUB") {
        this.has_addsub = true;
        this.has_fwd = false;
        this.has_cc = false;
        this.has_defer = false;
        this.has_notify = false;
        this.has_policy_route = false;
        this.has_notice_tem = false;
         this.has_timer_rdefer = false;
      } else if (a == "SETROUTE") {
        this.has_addsub = false;
        this.has_fwd = false;
        this.has_cc = false;
        this.has_defer = false;
        this.has_notify = false;
        this.has_policy_route = true;
        this.has_notice_tem = false;
         this.has_timer_rdefer = false;
      } else if (a == "NOTIFYRCPT" || a == "NOTIFYSENDER") {
        this.has_notice_tem = true;
        this.has_addsub = false;
        this.has_fwd = false;
        this.has_cc = false;
        this.has_defer = false;
        this.has_notify = false;
        this.has_policy_route = false;  
          this.has_timer_rdefer = false;
      } else if (a == "TIMERDEFER" ) {
        this.has_notice_tem = false;
        this.has_timer_rdefer = true;
        this.has_addsub = false;
        this.has_fwd = false;
        this.has_cc = false;
        this.has_defer = false;
        this.has_notify = false;
        this.has_policy_route = false;  
      }else {
         this.has_timer_rdefer = false;
        this.has_fwd = false;
        this.has_cc = false;
        this.has_defer = false;
        this.has_notify = false;
        this.has_addsub = false;
        this.has_policy_route = false;
        this.has_notice_tem = false;
      }
    },
    // 过滤策略加载
    getFileList1() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/aspam.cgi", {
          params: {
            __mode: "load_new_policy",
            sid: sid,
            is_white_rule:this.is_white_rule,
          },
        })
        .then((res) => {
          console.log(res);
            this.loading = false;

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            
             this.select_notify_template = res.data.ret.select_notify_template;
            this.tempalte_arr = res.data.ret.q_notify_template;
            this.envfrom1 = res.data.ret.envfrom;
            this.notify_body1 = res.data.ret.notify_body;
            this.notify_inc_eml1 = res.data.ret.notify_inc_eml;
            this.notify_subject1 = res.data.ret.notify_subject;
            this.policy_rule_select_arr = res.data.ret.q_select_newrule;
            // console.log( this.policy_rule_select_arr)
            this.select_combrule_arr = res.data.ret.q_select_combrule;
            this.policy_priv_show = res.data.ret.SYS_NEW_POLICY_CAN_SET_PRIV;
            this.policy_priv_add_edit = res.data.ret.q_policy_priv;
            this.checkedCities = res.data.ret.init_policy_priv;
            this.checkedCities_dafa = res.data.ret.init_policy_priv;
            this.manself_text = res.data.ret.man_self;
            this.manself = res.data.ret.manself;
            this.manself_show = res.data.ret.SYS_NEW_POLICY_SET_MANSELF;
            this.timer_hour_show=res.data.ret.TIMER_HOUR;
            this.timedefer_hint_show = res.data.ret.timedefer_hint;
               this.option_action_arr = res.data.ret.q_option_action ;
            this.timer_min=res.data.ret.TIMER_MIN;
            this.save_day = res.data.ret.SAVE_DAY;

            this.fileList = res.data.ret.datalist;
            this.new_comb_rule = res.data.ret.new_comb_rule;
            this.new_comb_rule_show = res.data.ret.SYS_NEWRULE_CAN_ADD_OLD_UNIT;
            this.new_policy_name = res.data.ret.new_policy_name;
            this.new_policy_rule = res.data.ret.new_policy_rule;
            this.priority = res.data.ret.priority;
            this.policy_action_arr = res.data.ret.q_policy_action;
            this.policy_type_arr = res.data.ret.q_policy_type;
            this.disableatoffline1 = res.data.ret.disableatoffline;
            this.alert_rate_minute = res.data.ret.alert_rate_minute;
            this.cc_email = res.data.ret.cc_email;
            this.defer_time1 = res.data.ret.defer_time;
            this.fwd_email = res.data.ret.fwd_email;
            this.multi_address_hint = res.data.ret.multi_address_hint;
            this.policy_comb_explam = res.data.ret.policy_comb_explam;
            this.policy_comb_name_hint = res.data.ret.policy_comb_name_hint;
            this.disableatoffline = res.data.ret.disableatoffline;
            this.notify_email = res.data.ret.notify_email;
            this.subflag = res.data.ret.subflag;
            // this.ip_domain_text = res.data.ret.ip_domain;
            // this.ip_domain_show = res.data.ret.IP_DOMAIN;
            this.notify_mode = res.data.ret.notify_mode;
            this.loading = false;
            this.RUN_ON_CENTER = res.data.ret.RUN_ON_CENTER;
            this.OFFLINE = res.data.ret.OFFLINE;
            this.CFGCHECK = res.data.ret.CFGCHECK;
            // console.log(this.RUN_ON_CENTER, this.OFFLINE, this.CFGCHECK)
          }
        });
    },
    save_policy_setting() {
      //   this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_notify_mode",
        sid: sid,

        policy_name: this.add_new_policy_name,
        notify_envfrom: this.notify_envfrom,
        notify_subject: this.notify_subject,
        notify_body_template: this.notify_body_template,

        notify_inc_eml: this.notify_inc_eml == true ? 1 : 0,
      });
      this.$axios
        .post(
          "/api/adm/cgi/aspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.getFileList1();
            this.tanchu_setting = false;
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },

    save_policy() {
      // this.loading = true;
this.$save_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_new_policy",
        sid: sid,
        template_name:this.template_name,
      is_white_rule:this.is_white_rule,
        save_day: this.radio_saveday == 0 ? 0 : this.save_day,
        newadd: this.newadd_fiter,
        policy_name: this.policy_name,
        policy_rule: this.policy_rule,
        comb_rule: this.comb_rule,
        direct: this.direct,
        active: this.active,
         option_act_on: this.option_select ==true ?1:0,
        option_act  :this.option_action ,
        option_policy_cc :this.option_policy_cc,

        runoncenter: this.runoncenter,
        disableatoffline: this.disableatoffline,
        cfgcheck: this.cfgcheck,
        policy_type: this.policy_type,
        priority: this.priority1,
        description: this.description,
        chkexpire: this.chkexpire == true ? 1 : 0,
        expire: this.expire,
        policy_action: this.policy_action,
        policy_fwd: this.policy_fwd,
        policy_cc: this.policy_cc,
        manself: this.manself,
        defer_time: this.defer_time,
        policy_addsub: this.policy_addsub,
        policy_nto: this.policy_nto,
        policy_route_json_str: this.policy_route_json_str,
        radio_poll: this.radio_poll,
        priv_json_str: JSON.stringify(this.checkedCities),
        notify_envfrom: this.notify_envfrom,
        notify_subject: this.notify_subject,
        notify_body_template: this.notify_body_template,
        timer_min:this.timer_min,
        timer_hour:this.timer_hour,
        notify_inc_eml: this.notify_inc_eml == true ? 1 : 0,
      });
      console.log(this.checkedCities, str.priv_json_str);
      this.$axios
        .post(
          "/api/adm/cgi/aspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          console.log(res);
this.$close_hint_test();
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.getFileList1();
            this.table_role_add = 0;
            this.table_role_show = 1;
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    // 通知设置编辑
    handleClick3(index, scope) {
      console.log(index, scope);

      // this.loading = true;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let policy_name = scope.POLICY_NAME;
      let str = this.$qs.stringify({
        __mode: "edit_notify_mode",
        sid: sid,
        policy_name: policy_name,
      });
      this.$axios.post("/api/adm/cgi/aspam.cgi", str).then((res) => {
        console.log(res);

        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.loading = false;
          this.tanchu_setting = true;
          // this.new_policy_name = res.data.ret.POLICY_NAME
          this.notify_envfrom = res.data.ret.NOTIFY_ENVFROM;
          this.notify_subject = res.data.ret.NOTIFY_SUBJECT;
          this.notify_body_template = res.data.ret.NOTIFY_CONTENT;
          this.add_new_policy_name = res.data.ret.POLICY_NAME;
          this.ip_domain = res.data.ret.IP_DOMAIN;
          this.radio_poll = res.data.ret.RADIO_POLL;
          this.notify_inc_eml = res.data.ret.NOTIFY_INC_EML == 1 ? true : false;
          this.new_policy_name1 = res.data.ret.new_policy_name;
          this.envfrom1 = res.data.ret.envfrom;
          this.notify_body1 = res.data.ret.notify_body;
          this.notify_inc_eml1 = res.data.ret.notify_inc_eml;
          this.notify_subject1 = res.data.ret.notify_subject;

          // this.getFileList1();
          // this.$message({
          //     type: "success",
          //     message: `${this.$t("anti_gs1_tan.del1")}`,
          // });
        }
      });
    },
    // 过滤策略 编辑
    handleClick2(index, scope) {
      if (scope.PRIV_JSON_STR) {
        this.checkedCities = JSON.parse(scope.PRIV_JSON_STR);
        console.log(this.checkedCities);
      } else {
        this.checkedCities = [];
      }
      this.isIndeterminate =
        this.checkedCities.length > 0 &&   this.checkedCities.length < this.policy_priv_add_edit.length;
          this.checkAll =  this.checkedCities.length === this.policy_priv_add_edit.length;
      this.policy_rule_select = "";
      this.select_combrule = "";
      console.log(index, scope);
      this.manself = scope.MANSELF;
      this.save_day = scope.SAVE_DAY;
      this.radio_saveday = scope.SAVE_DAY == 0 ? "0" : "1";
      console.log(this.radio_saveday);
      this.table_role_add = 1;
      this.newadd_fiter = 0;
      this.table_role_edit = 1;
      this.table_role_show = 0;
      this.template_name=scope.TEMPLATE_NAME;
      this.add_new_policy_name = scope.POLICY_NAME;
      (this.policy_name = scope.POLICY_NAME),
        (this.chkexpire = scope.CHKEXPIRE == 1 ? true : false),
        (this.policy_rule = scope.POLICY_RULE);
      (this.comb_rule = scope.COMB_RULE),
        (this.direct = scope.DIRECT),
        (this.active = scope.ACTIVE),
        (this.runoncenter = scope.RUNONCENTER),
        (this.disableatoffline = scope.DISOFFLINE),
        (this.cfgcheck = scope.CFGCHECK),
        (this.policy_type = scope.TYPE),
        (this.priority1 = scope.PRIORITY),
        (this.description = scope.DESCRIPTION),
        (this.expire = scope.EXPIRE),
        (this.policy_action = scope.ACTION),
        (this.policy_fwd = scope.FWD_EMAIL),
        (this.policy_cc = scope.CC_EMAIL),
        (this.defer_time = scope.DEFER_TIME),
        (this.policy_addsub = scope.SHOW_ADDSUB),
        (this.policy_nto = scope.NOTIFY_EMAIL),
        (this.change_show = scope.ACTION);
          this.option_policy_cc=scope.OPTION_POLICY_CC;
      this.option_action=scope.OPTION_ACT;
      this.option_select=scope.OPTION_ACT_ON==1?true:false;
      if(scope.OPTION_ACT=='CC'){
        this.has_cc_option=true
      }else{
        this.has_cc_option=false

      }
      this.policy_route_json_str = scope.ROUTE_JSON_STR;
      this.notify_envfrom = scope.NOTIFY_ENVFROM;
      this.notify_subject = scope.NOTIFY_SUBJECT;
      this.timer_hour=scope.TIMER_HOUR
      this.timer_min=scope.TIMER_MIN
      this.notify_body_template = scope.NOTIFY_CONTENT;
      this.notify_inc_eml = scope.NOTIFY_INC_EML == 1 ? true : false;
      // this.ip_domain = scope.IP_DOMAIN;
      if (this.change_show == "FWD") {
        this.has_fwd = true;
      } else if (this.change_show == "CC") {
        this.has_cc = true;
      } else if (this.change_show == "DEFER") {
        this.has_defer = true;
      } else if (this.change_show == "NOTIFYOTHER" ||this.change_show=="BYPASSANDTOOTHER") {
        this.has_notify = true;
         this.has_notice_tem = true;
      } else if (this.change_show == "ADDSUB") {
        this.has_addsub = true;
      } else if (this.change_show == "SETROUTE") {
        this.has_policy_route = true;
      } else if (this.change_show == "NOTIFYSENDER" || this.change_show == "NOTIFYRCPT") {
        this.has_notice_tem = true;
      }else if (this.change_show == "TIMERDEFER" ) {
       
        this.has_timer_rdefer = true;
       
      } else {
          this.has_timer_rdefer = false;
        this.has_notice_tem = false;
        this.has_fwd = false;
        this.has_cc = false;
        this.has_defer = false;
        this.has_notify = false;
        this.has_addsub = false;
        this.has_policy_route = false;
      }
    },
    // 过滤策略删除
    handleClick_reb(index, scope) {
      console.log(index, scope);
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let policy_name = scope.POLICY_NAME;
          let str = this.$qs.stringify({
            __mode: "del_new_policy",
            sid: sid,
            policy_name: policy_name,
          });
          this.$axios.post("/api/adm/cgi/aspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res) {
              this.loading = false;
            } else if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              this.loading = false;
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList1();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 显示

    add_role_show: function () {
      // console.log(this.checkedCities)
       this.checkedCities=this.checkedCities_dafa;
            this.isIndeterminate =
        this.checkedCities.length > 0 &&   this.checkedCities.length < this.policy_priv_add_edit.length;
          this.checkAll =  this.checkedCities.length === this.policy_priv_add_edit.length;
            this.option_policy_cc='';
      this.option_select=false;
      this.option_action='';
      this.has_cc_option = false;
      this.radio_saveday = "0";
      this.template_name='',
      this.save_day = "";
      this.newadd_fiter = 1;
      this.table_role_show = 0;
      this.table_role_edit = 0;
      this.table_role_add = 1;
      this.policy_name = "";
      this.policy_rule = "";
      this.policy_nto='';
      this.comb_rule = "";
      this.policy_rule_select = "";
      this.select_combrule = "";
      this.description = "";
      this.policy_type = 0;
      if(this.is_white_rule==1){
      this.policy_action = "OK";

      }else{
      this.policy_action = "REJECT";

      }
      this.priority1 = 0;
      this.direct = 1;
      this.active = 1;
      this.runoncenter = 0;
      this.disableatoffline = 0;
      // this.manself = 0;
      this.cfgcheck = 0;
      this.chkexpire = false;
      this.expire = "";
      this.has_fwd = false;
      this.has_cc = false;
      this.has_defer = false;
      this.has_notify = false;
      this.has_addsub = false;
      this.has_timer_rdefer = false;
      this.has_notice_tem = false;
      this.has_policy_route = false;
      this.has_policy_route = false;
      this.notify_envfrom = "";
      this.notify_subject = "";
      this.timer_hour=this.timer_hour_show
      this.timer_min=this.timer_min_show
      this.notify_body_template = "";
      this.notify_inc_eml = false;
      this.policy_route_json_str =
        '{"act":"alt-mailhost","rcpt":"example.com","route":"10.88.2.82,10.88.2.22.2","unpoll":1}';
    },

    tanOff: function () {
      this.tanchu = false;
    },
    tanOff_edit: function () {
      this.table_role_edit = 0;
      this.table_role_show = 1;
    },
    tanOff_setting: function () {
      this.tanchu_setting = false;
    },
    // 各行变色
    tableRowClassName({ rowIndex }) {
      // console.log(row,rowIndex)
      if (rowIndex % 2 == 1) {
        return "warning-row";
        // console.log(2222)
      } else if (rowIndex % 2 !== 1) {
        return "success-row";
      }
      return "";
    },

    // quxiao
    cancel_off() {
      this.xian1 = true;
      this.xian2 = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";
@import "../../css/lie_add_role.less";

/deep/ .has-gutter th {
  text-align: center;
}

/deep/ .has-gutter th:nth-child(2) {
  text-align: left;
}

/deep/ .has-gutter th:nth-child(3) {
  text-align: left;
}

/deep/ .has-gutter th:nth-child(4) {
  text-align: left;
}

/deep/ .has-gutter th:nth-child(5) {
  text-align: left;
}

/deep/ .has-gutter th:nth-child(16) {
  text-align: center;
}

/deep/ .el-table th {
  text-align: left;
}

// 表格居中位置
/deep/ .el-table__row td {
  text-align: left;
}

/deep/ .el-table__row td:nth-child(2) {
  text-align: left;
}

/deep/ .el-table__row td:nth-child(3) {
  text-align: left;
}

/deep/ .el-table__row td:nth-child(4) {
  text-align: left;
}

/deep/ .el-table__row td:nth-child(5) {
  text-align: left;
}
/deep/ .el-table__row td:nth-child(6) {
  text-align: left;
}
/deep/ .el-table__row td:last-child {
  text-align: left;
}

// /deep/ .el-tabs__nav {
//   padding-left: 14px;
// }

.pop-up1 {
  position: fixed;
  // padding: 20px 0;
  width: 44%;
  // height: 68%;
  top: 5%;
  left: 30%;
  z-index: 101;
  display: flex;
  flex: 1;
  overflow: auto;
  flex-direction: column;
  align-items: center;
  background: white;

  border-radius: 4px;
  //   margin-left: -12.5%;
  //   margin-top: -14%;
}
.pop-up1 .find1 {
  line-height: 30px;
}
.pop-up1 .find /deep/.el-input__inner {
  height: 24px !important;
  line-height: 24px !important;
}
.pop-up .el-radio-group {
  line-height: 30px;
  height: 30px;
}
.el-date-editor {
  margin-left: 10px;

  /deep/ .el-input__inner {
    padding-left: 30px;
  }
}

.tiaojian_a {
  border: 1px solid #ddd;
  padding: 0 10px !important;
}

.tiaojian_a ul {
  display: flex;
  align-items: center;

  font-size: 12px;
  border-bottom: 1px solid #ddd;

  li {
    padding: 0 10px;
  }
}

.tiaojian_a ol {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  align-items: center;
  .content_keyword_fang {
    display: flex;
    align-items: center;
  }
  li:nth-child(4) {
    padding-left: 10px;
  }

  li {
    padding-right: 10px;
  }

  /deep/.el-input {
    font-size: 12px;
  }
}
.tiaojian_a .tiaojian_a_child {
  .el-checkbox {
    margin-right: 0px;
  }
  .el-checkbox-group {
    width: 100%;
    margin: 2px 0;
  }
  .policy_priv_role {
    width: 15%;
  }
  flex-direction: column;
  align-items: flex-start;
  .content_keyword_fang {
    margin-bottom: 0px;
  }
  .content_keyword_fang_select {
    margin: 0;
    display: flex;
    width: 100%;
    justify-content: flex-start;
  }
}

/deep/ .el-radio__label {
  font-size: 12px;
}

// /deep/ .el-select {
//   display: flex;
//   justify-content: center;
// }

// 添加
.add1 {
  display: flex;
  align-items: center;
  font-size: 12px;
}

// 单选框
.check1 {
  margin: 0 10px;
}

.backText2 {
  margin-left: 40px;
}

.backText3 {
  margin-left: 30px;
}

.back1 .input5-1 {
  width: 100px;
}

.lie tbody td:nth-child(2) {
  display: flex;
  border-left: 1px solid #ddd;

  flex-direction: column;

  .el-input {
    width: 200px;
  }

  padding-left: 20px;

  div {
    padding: 2px 4px;
    margin: 5px 0;
  }
}

.alinkList_style {
  padding: 8px 0;
}

/deep/ .el-checkbox {
  display: flex;
  align-items: center;
  // line-height: 36px;
}

.ruel_find .find {
  width: 100%;
}

.ruel_find .block {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ruel_find_text {
  margin-right: 8px;
  color: #0e2c5e;
  width: 120px;
  text-align: right;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
}

.ruel_find {
  /deep/ .el-button {
    padding: 8px 16px;
    // margin-left: 10px;
    font-size: 12px;
    // background: #eceff4;
    margin-top: 14px;
    margin-right: 10px;
  }

  .el-button--primary {
    background: #006be7;
  }

  .el-button--danger {
    background: #f05f5f;
  }
}

.el-select__input {
  vertical-align: baseline;
}
// /deep/ .sent2 .cell {
//     color: #f00 !important;
// }
.table-fixed .cell img {
  width: 16px;
  height: 16px;
}
// /deep/ .el-table__body tr:hover {
//   cursor: pointer;
// }
/deep/ .table_hover tr td:nth-child(3) :hover {
  cursor: pointer;
}
/deep/ .table_hover tr td:nth-child(4) :hover {
  cursor: pointer;
}
.cursor_hover:hover {
  cursor: pointer;
}
.find-text {
  width: 170px;
}
/deep/ .block{
  width: 66%;
}
// /deep/ .el-table .cell{
//    padding: 8px 0px 8px 2px;
// }
/deep/ .el-input--suffix {
  line-height: 42px;
}
.notice_the_template_warp {
  padding-left: 0;
  // width: 100%;
  flex: 1;
}
.notice_the_template {
  display: flex;
  align-items: center;
  box-shadow: 0px -1px 0px 0px #d2d7e6;
}
</style>
